webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, alias2=container.lambda;

  return "<span role=\"button\" class=\"user "
    + alias1(__default(__webpack_require__(198)).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.nick : depth0),{"name":"colorClass","hash":{},"data":data}))
    + "\" data-name=\""
    + alias1(alias2((depth0 != null ? depth0.nick : depth0), depth0))
    + "\">"
    + alias1(alias2((depth0 != null ? depth0.mode : depth0), depth0))
    + alias1(alias2((depth0 != null ? depth0.nick : depth0), depth0))
    + "</span>\n";
},"useData":true});

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(1);
var io = __webpack_require__(248);
var path = window.location.pathname + "socket.io/";

var socket = io({
	transports: $(document.body).data("transports"),
	path: path,
	autoConnect: false,
	reconnection: false
});

["connect_error", "connect_failed", "disconnect", "error"].forEach(function (e) {
	socket.on(e, function (data) {
		$("#loading-page-message").text("Connection failed: " + data);
		$("#connection-error").addClass("shown").one("click", function () {
			window.onbeforeunload = null;
			window.location.reload();
		});

		// Disables sending a message by pressing Enter. `off` is necessary to
		// cancel `inputhistory`, which overrides hitting Enter. `on` is then
		// necessary to avoid creating new lines when hitting Enter without Shift.
		// This is fairly hacky but this solution is not permanent.
		$("#input").off("keydown").on("keydown", function (event) {
			if (event.which === 13 && !event.shiftKey) {
				event.preventDefault();
			}
		});
		// Hides the "Send Message" button
		$("#submit").remove();

		console.error(data);
	});
});

socket.on("connecting", function () {
	$("#loading-page-message").text("Connecting…");
});

socket.on("connect", function () {
	$("#loading-page-message").text("Finalizing connection…");
});

socket.on("authorized", function () {
	$("#loading-page-message").text("Authorized, loading messages…");
});

module.exports = socket;

/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Handlebars = __webpack_require__(2);
var parseStyle = __webpack_require__(199);
var findChannels = __webpack_require__(200);
var findLinks = __webpack_require__(213);
var merge = __webpack_require__(214);

// Create an HTML `span` with styling information for a given fragment
function createFragment(fragment) {
	var classes = [];
	if (fragment.bold) {
		classes.push("irc-bold");
	}
	if (fragment.textColor !== undefined) {
		classes.push("irc-fg" + fragment.textColor);
	}
	if (fragment.bgColor !== undefined) {
		classes.push("irc-bg" + fragment.bgColor);
	}
	if (fragment.italic) {
		classes.push("irc-italic");
	}
	if (fragment.underline) {
		classes.push("irc-underline");
	}

	var attributes = classes.length ? " class=\"" + classes.join(" ") + "\"" : "";
	var escapedText = Handlebars.Utils.escapeExpression(fragment.text);

	if (fragment.hexColor) {
		attributes += " style=\"color:#" + fragment.hexColor;

		if (fragment.hexBgColor) {
			attributes += ";background-color:#" + fragment.hexBgColor;
		}

		attributes += "\"";
	}

	if (attributes.length) {
		return "<span" + attributes + ">" + escapedText + "</span>";
	}

	return escapedText;
}

// Transform an IRC message potentially filled with styling control codes, URLs
// and channels into a string of HTML elements to display on the client.
module.exports = function parse(text) {
	// Extract the styling information and get the plain text version from it
	var styleFragments = parseStyle(text);
	var cleanText = styleFragments.map(function (fragment) {
		return fragment.text;
	}).join("");

	// On the plain text, find channels and URLs, returned as "parts". Parts are
	// arrays of objects containing start and end markers, as well as metadata
	// depending on what was found (channel or link).
	var channelPrefixes = ["#", "&"]; // TODO Channel prefixes should be RPL_ISUPPORT.CHANTYPES
	var userModes = ["!", "@", "%", "+"]; // TODO User modes should be RPL_ISUPPORT.PREFIX
	var channelParts = findChannels(cleanText, channelPrefixes, userModes);
	var linkParts = findLinks(cleanText);

	// Sort all parts identified based on their position in the original text
	var parts = channelParts.concat(linkParts).sort(function (a, b) {
		return a.start - b.start;
	});

	// Merge the styling information with the channels / URLs / text objects and
	// generate HTML strings with the resulting fragments
	return merge(parts, styleFragments).map(function (textPart) {
		// Create HTML strings with styling information
		var fragments = textPart.fragments.map(createFragment).join("");

		// Wrap these potentially styled fragments with links and channel buttons
		if (textPart.link) {
			var escapedLink = Handlebars.Utils.escapeExpression(textPart.link);
			return "<a href=\"" + escapedLink + "\" target=\"_blank\" rel=\"noopener\">" + fragments + "</a>";
		} else if (textPart.channel) {
			var escapedChannel = Handlebars.Utils.escapeExpression(textPart.channel);
			return "<span class=\"inline-channel\" role=\"button\" tabindex=\"0\" data-chan=\"" + escapedChannel + "\">" + fragments + "</span>";
		}

		return fragments;
	}).join("");
};

/***/ }),
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function() {
	return function() {};
};


/***/ }),
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	actions: {
		action: __webpack_require__(182),
		ban_list: __webpack_require__(217),
		channel_list: __webpack_require__(218),
		ctcp: __webpack_require__(219),
		invite: __webpack_require__(220),
		join: __webpack_require__(221),
		kick: __webpack_require__(222),
		mode: __webpack_require__(223),
		nick: __webpack_require__(224),
		part: __webpack_require__(225),
		quit: __webpack_require__(226),
		topic: __webpack_require__(227),
		topic_set_by: __webpack_require__(228),
		whois: __webpack_require__(229)
	},

	chan: __webpack_require__(152),
	chat: __webpack_require__(230),
	contextmenu_divider: __webpack_require__(231),
	contextmenu_item: __webpack_require__(232),
	date_marker: __webpack_require__(233),
	msg: __webpack_require__(236),
	msg_action: __webpack_require__(237),
	msg_preview: __webpack_require__(238),
	msg_preview_toggle: __webpack_require__(239),
	msg_unhandled: __webpack_require__(240),
	network: __webpack_require__(241),
	image_viewer: __webpack_require__(243),
	unread_marker: __webpack_require__(244),
	user: __webpack_require__(245),
	user_filtered: __webpack_require__(247),
	user_name: __webpack_require__(3)
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var moment = __webpack_require__(0);

module.exports = function (time) {
	return moment(time).format("D MMMM YYYY, HH:mm:ss");
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (a, b, opt) {
	a = a.toString();
	b = b.toString();
	if (a === b) {
		return opt.fn(this);
	}

	return opt.inverse(this);
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(1);
var settings = $("#settings");
var userStyles = $("#user-specified-css");
var storage = __webpack_require__(17);
var tz = __webpack_require__(19);

var windows = $("#windows");
var chat = $("#chat");

var options = $.extend({
	coloredNicks: true,
	desktopNotifications: false,
	join: true,
	links: true,
	mode: true,
	motd: true,
	nick: true,
	notification: true,
	notifyAllMessages: false,
	part: true,
	quit: true,
	showSeconds: false,
	theme: $("#theme").attr("href").replace(/^themes\/(.*).css$/, "$1"), // Extracts default theme name, set on the server configuration
	thumbnails: true,
	userStyles: userStyles.text(),
	highlights: [],
	autocomplete: true
}, JSON.parse(storage.get("settings")));

module.exports = options;

module.exports.shouldOpenMessagePreview = function (type) {
	return options.links && type === "link" || options.thumbnails && type === "image";
};

for (var i in options) {
	if (i === "userStyles") {
		if (!/[?&]nocss/.test(window.location.search)) {
			$(document.head).find("#user-specified-css").html(options[i]);
		}
		settings.find("#user-specified-css-input").val(options[i]);
	} else if (i === "highlights") {
		settings.find("input[name=" + i + "]").val(options[i]);
	} else if (i === "theme") {
		$("#theme").attr("href", "themes/" + options[i] + ".css");
		settings.find("select[name=" + i + "]").val(options[i]);
	} else if (options[i]) {
		settings.find("input[name=" + i + "]").prop("checked", true);
	}
}

settings.on("change", "input, select, textarea", function () {
	var self = $(this);
	var type = self.attr("type");
	var name = self.attr("name");

	if (type === "password") {
		return;
	} else if (type === "checkbox") {
		options[name] = self.prop("checked");
	} else {
		options[name] = self.val();
	}

	storage.set("settings", JSON.stringify(options));

	if (["join", "mode", "motd", "nick", "part", "quit", "notifyAllMessages"].indexOf(name) !== -1) {
		chat.toggleClass("hide-" + name, !self.prop("checked"));
	} else if (name === "coloredNicks") {
		chat.toggleClass("colored-nicks", self.prop("checked"));
	} else if (name === "theme") {
		$("#theme").attr("href", "themes/" + options[name] + ".css");
	} else if (name === "userStyles") {
		userStyles.html(options[name]);
	} else if (name === "highlights") {
		var highlightString = options[name];
		options.highlights = highlightString.split(",").map(function (h) {
			return h.trim();
		}).filter(function (h) {
			// Ensure we don't have empty string in the list of highlights
			// otherwise, users get notifications for everything
			return h !== "";
		});
	} else if (name === "showSeconds") {
		chat.find(".msg > .time").each(function () {
			$(this).text(tz($(this).parent().data("time")));
		});
	} else if (name === "autocomplete") {
		if (self.prop("checked")) {
			$("#input").trigger("autocomplete:on");
		} else {
			$("#input").textcomplete("destroy");
		}
	}
}).find("input").trigger("change");

$("#desktopNotifications").on("change", function () {
	if ($(this).prop("checked") && Notification.permission !== "granted") {
		Notification.requestPermission(updateDesktopNotificationStatus);
	}
});

// Updates the checkbox and warning in settings when the Settings page is
// opened or when the checkbox state is changed.
// When notifications are not supported, this is never called (because
// checkbox state can not be changed).
var updateDesktopNotificationStatus = function updateDesktopNotificationStatus() {
	if (Notification.permission === "denied") {
		desktopNotificationsCheckbox.attr("disabled", true);
		desktopNotificationsCheckbox.attr("checked", false);
		warningBlocked.show();
	} else {
		if (Notification.permission === "default" && desktopNotificationsCheckbox.prop("checked")) {
			desktopNotificationsCheckbox.attr("checked", false);
		}
		desktopNotificationsCheckbox.attr("disabled", false);
		warningBlocked.hide();
	}
};

// If browser does not support notifications, override existing settings and
// display proper message in settings.
var desktopNotificationsCheckbox = $("#desktopNotifications");
var warningUnsupported = $("#warnUnsupportedDesktopNotifications");
var warningBlocked = $("#warnBlockedDesktopNotifications");
warningBlocked.hide();
if ("Notification" in window) {
	warningUnsupported.hide();
	windows.on("show", "#settings", updateDesktopNotificationStatus);
} else {
	options.desktopNotifications = false;
	desktopNotificationsCheckbox.attr("disabled", true);
	desktopNotificationsCheckbox.attr("checked", false);
}

/***/ }),
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(1);
var templates = __webpack_require__(10);
var options = __webpack_require__(13);
var renderPreview = __webpack_require__(167);
var utils = __webpack_require__(28);
var sorting = __webpack_require__(276);

var chat = $("#chat");
var sidebar = $("#sidebar");

module.exports = {
	buildChannelMessages: buildChannelMessages,
	buildChatMessage: buildChatMessage,
	renderChannel: renderChannel,
	renderChannelMessages: renderChannelMessages,
	renderChannelUsers: renderChannelUsers,
	renderNetworks: renderNetworks
};

function buildChannelMessages(channel, messages) {
	return messages.reduce(function (docFragment, message) {
		docFragment.append(buildChatMessage({
			chan: channel,
			msg: message
		}));
		return docFragment;
	}, $(document.createDocumentFragment()));
}

function buildChatMessage(data) {
	var type = data.msg.type;
	var target = "#chan-" + data.chan;
	if (type === "error") {
		target = "#chan-" + chat.find(".active").data("id");
	}

	var chan = chat.find(target);
	var template = "msg";

	if (!data.msg.highlight && !data.msg.self && (type === "message" || type === "notice") && options.highlights.some(function (h) {
		return data.msg.text.toLocaleLowerCase().indexOf(h.toLocaleLowerCase()) > -1;
	})) {
		data.msg.highlight = true;
	}

	if (["invite", "join", "mode", "kick", "nick", "part", "quit", "topic", "topic_set_by", "action", "whois", "ctcp", "channel_list", "ban_list"].indexOf(type) !== -1) {
		template = "msg_action";
	} else if (type === "unhandled") {
		template = "msg_unhandled";
	}

	var msg = $(templates[template](data.msg));
	var content = msg.find(".content");

	if (template === "msg_action") {
		content.html(templates.actions[type](data.msg));
	}

	data.msg.previews.forEach(function (preview) {
		renderPreview(preview, msg);
	});

	if ((type === "message" || type === "action" || type === "notice") && chan.hasClass("channel")) {
		var nicks = chan.find(".users").data("nicks");
		if (nicks) {
			var find = nicks.indexOf(data.msg.from);
			if (find !== -1) {
				nicks.splice(find, 1);
				nicks.unshift(data.msg.from);
			}
		}
	}

	return msg;
}

function renderChannel(data) {
	renderChannelMessages(data);

	if (data.type === "channel") {
		renderChannelUsers(data);
	}
}

function renderChannelMessages(data) {
	var documentFragment = buildChannelMessages(data.id, data.messages);
	var channel = chat.find("#chan-" + data.id + " .messages").append(documentFragment);

	if (data.firstUnread > 0) {
		var first = channel.find("#msg-" + data.firstUnread);

		// TODO: If the message is far off in the history, we still need to append the marker into DOM
		if (!first.length) {
			channel.prepend(templates.unread_marker());
		} else {
			first.before(templates.unread_marker());
		}
	} else {
		channel.append(templates.unread_marker());
	}

	if (data.type !== "lobby") {
		var lastDate = void 0;
		$(chat.find("#chan-" + data.id + " .messages .msg[data-time]")).each(function () {
			var msg = $(this);
			var msgDate = new Date(msg.attr("data-time"));

			// Top-most message in a channel
			if (!lastDate) {
				lastDate = msgDate;
				msg.before(templates.date_marker({ msgDate: msgDate }));
			}

			if (lastDate.toDateString() !== msgDate.toDateString()) {
				msg.before(templates.date_marker({ msgDate: msgDate }));
			}

			lastDate = msgDate;
		});
	}
}

function renderChannelUsers(data) {
	var users = chat.find("#chan-" + data.id).find(".users");
	var nicks = data.users.concat() // Make a copy of the user list, sort is applied in-place
	.sort(function (a, b) {
		return b.lastMessage - a.lastMessage;
	}).map(function (a) {
		return a.nick;
	});

	var search = users.find(".search").attr("placeholder", nicks.length + " " + (nicks.length === 1 ? "user" : "users"));

	users.data("nicks", nicks).find(".names-original").html(templates.user(data));

	// Refresh user search
	if (search.val().length) {
		search.trigger("input");
	}
}

function renderNetworks(data) {
	sidebar.find(".empty").hide();
	sidebar.find(".networks").append(templates.network({
		networks: data.networks
	}));

	var channels = $.map(data.networks, function (n) {
		return n.channels;
	});
	chat.append(templates.chat({
		channels: channels
	}));
	channels.forEach(function (channel) {
		renderChannel(channel);

		if (channel.type === "channel") {
			chat.find("#chan-" + channel.id).data("needsNamesRefresh", true);
		}
	});

	utils.confirmExit();
	sorting();

	if (sidebar.find(".highlight").length) {
		utils.toggleNotificationMarkers(true);
	}
}

/***/ }),
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	set: function set(key, value) {
		try {
			window.localStorage.setItem(key, value);
		} catch (e) {
			// Do nothing. If we end up here, web storage quota exceeded, or user is
			// in Safari's private browsing where localStorage's setItem is not
			// available. See http://stackoverflow.com/q/14555347/1935861.
		}
	},
	get: function get(key) {
		return window.localStorage.getItem(key);
	},
	remove: function remove(key, value) {
		window.localStorage.removeItem(key, value);
	}
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (orig) {
	return orig.toLowerCase().replace(/[^a-z0-9]/, "-");
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var moment = __webpack_require__(0);
var constants = __webpack_require__(153);

module.exports = function (time) {
	var options = __webpack_require__(13);
	var format = options.showSeconds ? constants.timeFormats.msgWithSeconds : constants.timeFormats.msgDefault;
	return moment(time).format(format);
};

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(1);
var chat = $("#chat");
var input = $("#input");

module.exports = {
	clear: clear,
	confirmExit: confirmExit,
	forceFocus: forceFocus,
	move: move,
	resetHeight: resetHeight,
	setNick: setNick,
	toggleNickEditor: toggleNickEditor,
	toggleNotificationMarkers: toggleNotificationMarkers
};

function resetHeight(element) {
	element.style.height = element.style.minHeight;
}

// Triggering click event opens the virtual keyboard on mobile
// This can only be called from another interactive event (e.g. button click)
function forceFocus() {
	input.trigger("click").focus();
}

function clear() {
	chat.find(".active").find(".show-more").addClass("show").end().find(".messages .msg, .date-marker-container").remove();
}

function toggleNickEditor(toggle) {
	$("#nick").toggleClass("editable", toggle);
	$("#nick-value").attr("contenteditable", toggle);
}

function setNick(nick) {
	// Closes the nick editor when canceling, changing channel, or when a nick
	// is set in a different tab / browser / device.
	toggleNickEditor(false);

	$("#nick-value").text(nick);
}

var favicon = $("#favicon");

function toggleNotificationMarkers(newState) {
	// Toggles the favicon to red when there are unread notifications
	if (favicon.data("toggled") !== newState) {
		var old = favicon.attr("href");
		favicon.attr("href", favicon.data("other"));
		favicon.data("other", old);
		favicon.data("toggled", newState);
	}

	// Toggles a dot on the menu icon when there are unread notifications
	$("#viewport .lt").toggleClass("notified", newState);
}

function confirmExit() {
	if ($("body").hasClass("public")) {
		window.onbeforeunload = function () {
			return "Are you sure you want to navigate away from this page?";
		};
	}
}

function move(array, old_index, new_index) {
	if (new_index >= array.length) {
		var k = new_index - array.length;
		while (k-- + 1) {
			this.push(undefined);
		}
	}
	array.splice(new_index, 0, array.splice(old_index, 1)[0]);
	return array;
}

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (count) {
	if (count < 1000) {
		return count;
	}

	return (count / 1000).toFixed(2).slice(0, -1) + "k";
};

/***/ }),
/* 151 */,
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div data-id=\""
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\" data-target=\"#chan-"
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\" data-title=\""
    + alias2(alias1((depth0 != null ? depth0.name : depth0), depth0))
    + "\" class=\"chan "
    + alias2(alias1((depth0 != null ? depth0.type : depth0), depth0))
    + " chan-"
    + alias2(__default(__webpack_require__(18)).call(alias3,(depth0 != null ? depth0.name : depth0),{"name":"slugify","hash":{},"data":data}))
    + "\">\n	<span class=\"badge"
    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.highlight : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\">"
    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.unread : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</span>\n	<button class=\"close\" aria-label=\"Close\"></button>\n	<span class=\"name\" title=\""
    + alias2(alias1((depth0 != null ? depth0.name : depth0), depth0))
    + "\">"
    + alias2(alias1((depth0 != null ? depth0.name : depth0), depth0))
    + "</span>\n</div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    return " highlight";
},"4":function(container,depth0,helpers,partials,data) {
    return container.escapeExpression(__default(__webpack_require__(150)).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.unread : depth0),{"name":"roundBadgeNumber","hash":{},"data":data}));
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.channels : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"useData":true});

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var colorCodeMap = [["00", "White"], ["01", "Black"], ["02", "Blue"], ["03", "Green"], ["04", "Red"], ["05", "Brown"], ["06", "Magenta"], ["07", "Orange"], ["08", "Yellow"], ["09", "Light Green"], ["10", "Cyan"], ["11", "Light Cyan"], ["12", "Light Blue"], ["13", "Pink"], ["14", "Grey"], ["15", "Light Grey"]];

var commands = ["/away", "/back", "/ban", "/banlist", "/close", "/collapse", "/connect", "/ctcp", "/deop", "/devoice", "/disconnect", "/expand", "/invite", "/join", "/kick", "/leave", "/me", "/mode", "/msg", "/nick", "/notice", "/op", "/part", "/query", "/quit", "/raw", "/say", "/send", "/server", "/slap", "/topic", "/unban", "/voice", "/whois"];

var timeFormats = {
	msgDefault: "HH:mm",
	msgWithSeconds: "HH:mm:ss"
};

module.exports = {
	colorCodeMap: colorCodeMap,
	timeFormats: timeFormats,
	commands: commands
};

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var diff;

module.exports = function (a, opt) {
	if (a !== diff) {
		diff = a;
		return opt.fn(this);
	}

	return opt.inverse(this);
};

/***/ }),
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(1);
var options = __webpack_require__(13);
var socket = __webpack_require__(4);
var templates = __webpack_require__(10);
var input = $("#input");

module.exports = renderPreview;

function renderPreview(preview, msg) {
	if (preview.type === "loading") {
		return;
	}

	var escapedLink = preview.link.replace(/["\\]/g, "\\$&");
	var previewContainer = msg.find(".preview[data-url=\"" + escapedLink + "\"]");

	// This is to fix a very rare case of rendering a preview twice
	// This happens when a very large amount of messages is being sent to the client
	// and they get queued, so the `preview` object on the server has time to load before
	// it actually gets sent to the server, which makes the loaded preview sent twice,
	// once in `msg` and another in `msg:preview`
	if (!previewContainer.is(":empty")) {
		return;
	}

	preview.shown = preview.shown && options.shouldOpenMessagePreview(preview.type);

	var container = msg.closest(".chat");
	var bottom = false;
	if (container.length) {
		bottom = container.isScrollBottom();
	}

	msg.find(".text a[href=\"" + escapedLink + "\"]").first().after(templates.msg_preview_toggle({ preview: preview }).trim());

	previewContainer.append(templates.msg_preview({ preview: preview }));

	if (preview.shown && bottom) {
		handleImageInPreview(msg.find(".toggle-content"), container);
	}

	container.trigger("keepToBottom");
}

$("#chat").on("click", ".toggle-button", function () {
	var self = $(this);
	var container = self.closest(".chat");
	var content = self.closest(".content").find(".preview[data-url=\"" + self.data("url") + "\"] .toggle-content");
	var bottom = container.isScrollBottom();

	if (bottom && !content.hasClass("show")) {
		handleImageInPreview(content, container);
	}

	self.toggleClass("opened");
	content.toggleClass("show");

	// Tell the server we're toggling so it remembers at page reload
	// TODO Avoid sending many single events when using `/collapse` or `/expand`
	// See https://github.com/thelounge/lounge/issues/1377
	socket.emit("msg:preview:toggle", {
		target: parseInt(self.closest(".chan").data("id"), 10),
		msgId: parseInt(self.closest(".msg").attr("id").replace("msg-", ""), 10),
		link: self.data("url"),
		shown: content.hasClass("show")
	});

	// If scrollbar was at the bottom before toggling the preview, keep it at the bottom
	if (bottom) {
		container.scrollBottom();
	}
});

function handleImageInPreview(content, container) {
	var img = content.find("img");

	// Trigger scroll logic after the image loads
	if (img.length && !img.width()) {
		img.on("load", function () {
			container.trigger("keepToBottom");
		});
	}
}

/* Image viewer */

var imageViewer = $("#image-viewer");

$("#chat").on("click", ".toggle-thumbnail", function () {
	var link = $(this);

	openImageViewer(link);

	// Prevent the link to open a new page since we're opening the image viewer,
	// but keep it a link to allow for Ctrl/Cmd+click.
	// By binding this event on #chat we prevent input gaining focus after clicking.
	return false;
});

imageViewer.on("click", function () {
	closeImageViewer();
});

$(document).keydown(function (e) {
	switch (e.keyCode ? e.keyCode : e.which) {
		case 27:
			// Escape
			closeImageViewer();
			break;
		case 37:
			// Left arrow
			if (imageViewer.hasClass("opened")) {
				imageViewer.find(".previous-image-btn").click();
			}
			break;
		case 39:
			// Right arrow
			if (imageViewer.hasClass("opened")) {
				imageViewer.find(".next-image-btn").click();
			}
			break;
	}
});

function openImageViewer(link) {
	$(".previous-image").removeClass("previous-image");
	$(".next-image").removeClass("next-image");

	// The next two blocks figure out what are the previous/next images. We first
	// look within the same message, as there can be multiple thumbnails per
	// message, and if not, we look at previous/next messages and take the
	// last/first thumbnail available.
	// Only expanded thumbnails are being cycled through.

	// Previous image
	var previousImage = link.closest(".preview").prev(".preview").find(".toggle-content.show .toggle-thumbnail").last();
	if (!previousImage.length) {
		previousImage = link.closest(".msg").prevAll().find(".toggle-content.show .toggle-thumbnail").last();
	}
	previousImage.addClass("previous-image");

	// Next image
	var nextImage = link.closest(".preview").next(".preview").find(".toggle-content.show .toggle-thumbnail").first();
	if (!nextImage.length) {
		nextImage = link.closest(".msg").nextAll().find(".toggle-content.show .toggle-thumbnail").first();
	}
	nextImage.addClass("next-image");

	imageViewer.html(templates.image_viewer({
		image: link.find("img").attr("src"),
		link: link.attr("href"),
		type: link.parent().hasClass("toggle-type-image") ? "image" : "link",
		hasPreviousImage: previousImage.length > 0,
		hasNextImage: nextImage.length > 0
	}));

	imageViewer.addClass("opened");
}

imageViewer.on("click", ".previous-image-btn", function () {
	$(".previous-image").click();
	return false;
});

imageViewer.on("click", ".next-image-btn", function () {
	$(".next-image").click();
	return false;
});

function closeImageViewer() {
	imageViewer.removeClass("opened").one("transitionend", function () {
		imageViewer.empty();
	});

	input.focus();
}

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// vendor libraries

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

__webpack_require__(169);
__webpack_require__(173);
var $ = __webpack_require__(1);
var moment = __webpack_require__(0);
var Mousetrap = __webpack_require__(175);
var URI = __webpack_require__(146);
var fuzzy = __webpack_require__(176);

// our libraries
var emojiMap = __webpack_require__(177);
__webpack_require__(178);
__webpack_require__(179);
__webpack_require__(180);
var helpers_roundBadgeNumber = __webpack_require__(150);
var slideoutMenu = __webpack_require__(181);
var templates = __webpack_require__(10);
var socket = __webpack_require__(4);
__webpack_require__(272);
var constants = __webpack_require__(153);
var storage = __webpack_require__(17);
var utils = __webpack_require__(28);

$(function () {
	var sidebar = $("#sidebar, #footer");
	var chat = $("#chat");

	$(document.body).data("app-name", document.title);

	var pop;
	try {
		pop = new Audio();
		pop.src = "audio/pop.ogg";
	} catch (e) {
		pop = {
			play: $.noop
		};
	}

	$("#play").on("click", function () {
		pop.play();
	});

	// Autocompletion Strategies

	var emojiSearchTerms = Object.keys(emojiMap);
	var emojiStrategy = {
		id: "emoji",
		match: /\B:([-+\w]*):?$/,
		search: function search(term, callback) {
			var results = fuzzy.filter(term, emojiSearchTerms, {
				pre: "<b>",
				post: "</b>"
			});
			callback(results.map(function (el) {
				return [el.string, el.original];
			}));
		},
		template: function template(_ref) {
			var _ref2 = _slicedToArray(_ref, 2),
			    string = _ref2[0],
			    original = _ref2[1];

			return "<span class=\"emoji\">" + emojiMap[original] + "</span> " + string;
		},
		replace: function replace(_ref3) {
			var _ref4 = _slicedToArray(_ref3, 2),
			    original = _ref4[1];

			return emojiMap[original];
		},

		index: 1
	};

	var nicksStrategy = {
		id: "nicks",
		match: /\B(@([a-zA-Z_[\]\\^{}|`@][a-zA-Z0-9_[\]\\^{}|`-]*)?)$/,
		search: function search(term, callback) {
			term = term.slice(1);
			if (term[0] === "@") {
				callback(completeNicks(term.slice(1)).map(function (val) {
					return "@" + val;
				}));
			} else {
				callback(completeNicks(term));
			}
		},
		template: function template(value) {
			return value;
		},
		replace: function replace(value) {
			return value;
		},

		index: 1
	};

	var chanStrategy = {
		id: "chans",
		match: /\B((#|\+|&|![A-Z0-9]{5})([^\x00\x0A\x0D\x20\x2C\x3A]+(:[^\x00\x0A\x0D\x20\x2C\x3A]*)?)?)$/,
		search: function search(term, callback, match) {
			callback(completeChans(match[0]));
		},
		template: function template(value) {
			return value;
		},
		replace: function replace(value) {
			return value;
		},

		index: 1
	};

	var commandStrategy = {
		id: "commands",
		match: /^\/(\w*)$/,
		search: function search(term, callback) {
			callback(completeCommands("/" + term));
		},
		template: function template(value) {
			return value;
		},
		replace: function replace(value) {
			return value;
		},

		index: 1
	};

	var foregroundColorStrategy = {
		id: "foreground-colors",
		match: /\x03(\d{0,2}|[A-Za-z ]{0,10})$/,
		search: function search(term, callback) {
			term = term.toLowerCase();
			var matchingColorCodes = constants.colorCodeMap.filter(function (i) {
				return i[0].startsWith(term) || i[1].toLowerCase().startsWith(term);
			});

			callback(matchingColorCodes);
		},
		template: function template(value) {
			return "<span class=\"irc-fg" + parseInt(value[0], 10) + "\">" + value[1] + "</span>";
		},
		replace: function replace(value) {
			return "\x03" + value[0];
		},

		index: 1
	};

	var backgroundColorStrategy = {
		id: "background-colors",
		match: /\x03(\d{2}),(\d{0,2}|[A-Za-z ]{0,10})$/,
		search: function search(term, callback, match) {
			term = term.toLowerCase();
			var matchingColorCodes = constants.colorCodeMap.filter(function (i) {
				return i[0].startsWith(term) || i[1].toLowerCase().startsWith(term);
			}).map(function (pair) {
				return pair.concat(match[1]);
			}); // Needed to pass fg color to `template`...

			callback(matchingColorCodes);
		},
		template: function template(value) {
			return "<span class=\"irc-fg" + parseInt(value[2], 10) + " irc-bg irc-bg" + parseInt(value[0], 10) + "\">" + value[1] + "</span>";
		},
		replace: function replace(value) {
			return "\x03$1," + value[0];
		},

		index: 2
	};

	var options = __webpack_require__(13);

	var windows = $("#windows");

	var viewport = $("#viewport");
	var sidebarSlide = slideoutMenu(viewport[0], sidebar[0]);
	var contextMenuContainer = $("#context-menu-container");
	var contextMenu = $("#context-menu");

	$("#main").on("click", function (e) {
		if ($(e.target).is(".lt")) {
			sidebarSlide.toggle(!sidebarSlide.isOpen());
		} else if (sidebarSlide.isOpen()) {
			sidebarSlide.toggle(false);
		}
	});

	viewport.on("click", ".rt", function (e) {
		var self = $(this);
		viewport.toggleClass(self.attr("class"));
		e.stopPropagation();
		chat.find(".chan.active .chat").trigger("msg.sticky");
	});

	function positionContextMenu(that, e) {
		var offset;
		var menuWidth = contextMenu.outerWidth();
		var menuHeight = contextMenu.outerHeight();

		if (that.hasClass("menu")) {
			offset = that.offset();
			offset.left -= menuWidth - that.outerWidth();
			offset.top += that.outerHeight();
			return offset;
		}

		offset = { left: e.pageX, top: e.pageY };

		if (window.innerWidth - offset.left < menuWidth) {
			offset.left = window.innerWidth - menuWidth;
		}

		if (window.innerHeight - offset.top < menuHeight) {
			offset.top = window.innerHeight - menuHeight;
		}

		return offset;
	}

	function showContextMenu(that, e) {
		var target = $(e.currentTarget);
		var output = "";

		if (target.hasClass("user")) {
			output = templates.contextmenu_item({
				class: "user",
				text: target.text(),
				data: target.data("name")
			});
		} else if (target.hasClass("chan")) {
			output = templates.contextmenu_item({
				class: "chan",
				text: target.data("title"),
				data: target.data("target")
			});
			output += templates.contextmenu_divider();
			output += templates.contextmenu_item({
				class: "close",
				text: target.hasClass("lobby") ? "Disconnect" : target.hasClass("channel") ? "Leave" : "Close",
				data: target.data("target")
			});
		}

		contextMenuContainer.show();
		contextMenu.html(output).css(positionContextMenu($(that), e));

		return false;
	}

	viewport.on("contextmenu", ".user, .network .chan", function (e) {
		return showContextMenu(this, e);
	});

	viewport.on("click", "#chat .menu", function (e) {
		e.currentTarget = $(e.currentTarget).closest(".chan")[0];
		return showContextMenu(this, e);
	});

	contextMenuContainer.on("click contextmenu", function () {
		contextMenuContainer.hide();
		return false;
	});

	function resetInputHeight(input) {
		input.style.height = input.style.minHeight;
	}

	var input = $("#input").history().on("input", function () {
		var style = window.getComputedStyle(this);

		// Start by resetting height before computing as scrollHeight does not
		// decrease when deleting characters
		resetInputHeight(this);

		this.style.height = Math.min(Math.round(window.innerHeight - 100), // prevent overflow
		this.scrollHeight + Math.round(parseFloat(style.borderTopWidth) || 0) + Math.round(parseFloat(style.borderBottomWidth) || 0)) + "px";

		chat.find(".chan.active .chat").trigger("msg.sticky"); // fix growing
	}).tab(completeNicks, { hint: false }).on("autocomplete:on", function () {
		enableAutocomplete();
	});

	if (options.autocomplete) {
		enableAutocomplete();
	}

	function enableAutocomplete() {
		input.textcomplete([emojiStrategy, nicksStrategy, chanStrategy, commandStrategy, foregroundColorStrategy, backgroundColorStrategy], {
			dropdownClassName: "textcomplete-menu",
			placement: "top"
		}).on({
			"textComplete:show": function textCompleteShow() {
				$(this).data("autocompleting", true);
			},
			"textComplete:hide": function textCompleteHide() {
				$(this).data("autocompleting", false);
			}
		});
	}

	var focus = $.noop;
	if (!("ontouchstart" in window || navigator.maxTouchPoints > 0)) {
		focus = function focus() {
			if (chat.find(".active").hasClass("chan")) {
				input.focus();
			}
		};

		$(window).on("focus", focus);

		chat.on("click", ".chat", function () {
			setTimeout(function () {
				var text = "";
				if (window.getSelection) {
					text = window.getSelection().toString();
				} else if (document.selection && document.selection.type !== "Control") {
					text = document.selection.createRange().text;
				}
				if (!text) {
					focus();
				}
			}, 2);
		});
	}

	$("#form").on("submit", function (e) {
		e.preventDefault();
		utils.forceFocus();
		var text = input.val();

		if (text.length === 0) {
			return;
		}

		input.val("");
		resetInputHeight(input.get(0));

		if (text.indexOf("/clear") === 0) {
			utils.clear();
			return;
		}

		if (text.indexOf("/collapse") === 0) {
			$(".chan.active .toggle-button.opened").click();
			return;
		}

		if (text.indexOf("/expand") === 0) {
			$(".chan.active .toggle-button:not(.opened)").click();
			return;
		}

		socket.emit("input", {
			target: chat.data("id"),
			text: text
		});
	});

	function findCurrentNetworkChan(name) {
		name = name.toLowerCase();

		return $(".network .chan.active").parent(".network").find(".chan").filter(function () {
			return $(this).data("title").toLowerCase() === name;
		}).first();
	}

	$("button#set-nick").on("click", function () {
		utils.toggleNickEditor(true);

		// Selects existing nick in the editable text field
		var element = document.querySelector("#nick-value");
		element.focus();
		var range = document.createRange();
		range.selectNodeContents(element);
		var selection = window.getSelection();
		selection.removeAllRanges();
		selection.addRange(range);
	});

	$("button#cancel-nick").on("click", cancelNick);
	$("button#submit-nick").on("click", submitNick);

	function submitNick() {
		var newNick = $("#nick-value").text().trim();

		if (newNick.length === 0) {
			cancelNick();
			return;
		}

		utils.toggleNickEditor(false);

		socket.emit("input", {
			target: chat.data("id"),
			text: "/nick " + newNick
		});
	}

	function cancelNick() {
		utils.setNick(sidebar.find(".chan.active").closest(".network").data("nick"));
	}

	$("#nick-value").keypress(function (e) {
		switch (e.keyCode ? e.keyCode : e.which) {
			case 13:
				// Enter
				// Ensures a new line is not added when pressing Enter
				e.preventDefault();
				break;
		}
	}).keyup(function (e) {
		switch (e.keyCode ? e.keyCode : e.which) {
			case 13:
				// Enter
				submitNick();
				break;
			case 27:
				// Escape
				cancelNick();
				break;
		}
	});

	chat.on("click", ".inline-channel", function () {
		var name = $(this).data("chan");
		var chan = findCurrentNetworkChan(name);

		if (chan.length) {
			chan.click();
		} else {
			socket.emit("input", {
				target: chat.data("id"),
				text: "/join " + name
			});
		}
	});

	chat.on("click", ".user", function () {
		var name = $(this).data("name");
		var chan = findCurrentNetworkChan(name);

		if (chan.length) {
			chan.click();
		}

		socket.emit("input", {
			target: chat.data("id"),
			text: "/whois " + name
		});
	});

	sidebar.on("click", ".chan, button", function (e, data) {
		// Pushes states to history web API when clicking elements with a data-target attribute.
		// States are very trivial and only contain a single `clickTarget` property which
		// contains a CSS selector that targets elements which takes the user to a different view
		// when clicked. The `popstate` event listener will trigger synthetic click events using that
		// selector and thus take the user to a different view/state.
		if (data && data.pushState === false) {
			return;
		}
		var self = $(this);
		var target = self.data("target");
		if (!target) {
			return;
		}
		var state = {};

		if (self.hasClass("chan")) {
			state.clickTarget = ".chan[data-id=\"" + self.data("id") + "\"]";
		} else {
			state.clickTarget = "#footer button[data-target=\"" + target + "\"]";
		}

		if (history && history.pushState) {
			if (data && data.replaceHistory && history.replaceState) {
				history.replaceState(state, null, null);
			} else {
				history.pushState(state, null, null);
			}
		}
	});

	sidebar.on("click", ".chan, button", function () {
		var self = $(this);
		var target = self.data("target");
		if (!target) {
			return;
		}

		chat.data("id", self.data("id"));
		socket.emit("open", self.data("id"));

		sidebar.find(".active").removeClass("active");
		self.addClass("active").find(".badge").removeClass("highlight").empty();

		if (sidebar.find(".highlight").length === 0) {
			utils.toggleNotificationMarkers(false);
		}

		sidebarSlide.toggle(false);

		var lastActive = $("#windows > .active");

		lastActive.removeClass("active").find(".chat").unsticky();

		var lastActiveChan = lastActive.find(".chan.active").removeClass("active");

		lastActiveChan.find(".unread-marker").appendTo(lastActiveChan.find(".messages"));

		var chan = $(target).addClass("active").trigger("show");

		var title = $(document.body).data("app-name");
		if (chan.data("title")) {
			title = chan.data("title") + " — " + title;
		}
		document.title = title;

		var placeholder = "";
		if (chan.data("type") === "channel" || chan.data("type") === "query") {
			placeholder = "Write to " + chan.data("title");
		}
		input.attr("placeholder", placeholder);

		if (self.hasClass("chan")) {
			$("#chat-container").addClass("active");
			utils.setNick(self.closest(".network").data("nick"));
		}

		var chanChat = chan.find(".chat");
		if (chanChat.length > 0 && chan.data("type") !== "special") {
			chanChat.sticky();
		}

		if (chan.data("needsNamesRefresh") === true) {
			chan.data("needsNamesRefresh", false);
			socket.emit("names", { target: self.data("id") });
		}

		focus();
	});

	sidebar.on("click", "#sign-out", function () {
		storage.remove("token");
		location.reload();
	});

	sidebar.on("click", ".close", function () {
		var cmd = "/close";
		var chan = $(this).closest(".chan");
		if (chan.hasClass("lobby")) {
			cmd = "/quit";
			var server = chan.find(".name").html();
			if (!confirm("Disconnect from " + server + "?")) {
				return false;
			}
		}
		socket.emit("input", {
			target: chan.data("id"),
			text: cmd
		});
		chan.css({
			transition: "none",
			opacity: 0.4
		});
		return false;
	});

	contextMenu.on("click", ".context-menu-item", function () {
		switch ($(this).data("action")) {
			case "close":
				$(".networks .chan[data-target='" + $(this).data("data") + "'] .close").click();
				break;
			case "chan":
				$(".networks .chan[data-target='" + $(this).data("data") + "']").click();
				break;
			case "user":
				$(".channel.active .users .user[data-name='" + $(this).data("data") + "']").click();
				break;
		}
	});

	chat.on("input", ".search", function () {
		var value = $(this).val();
		var parent = $(this).closest(".users");
		var names = parent.find(".names-original");
		var container = parent.find(".names-filtered");

		if (!value.length) {
			container.hide();
			names.show();
			return;
		}

		var fuzzyOptions = {
			pre: "<b>",
			post: "</b>",
			extract: function extract(el) {
				return $(el).text();
			}
		};

		var result = fuzzy.filter(value, names.find(".user").toArray(), fuzzyOptions);

		names.hide();
		container.html(templates.user_filtered({ matches: result })).show();
	});

	chat.on("msg", ".messages", function (e, target, msg) {
		var unread = msg.unread;
		msg = msg.msg;

		if (msg.self) {
			return;
		}

		var button = sidebar.find(".chan[data-target='" + target + "']");
		if (msg.highlight || options.notifyAllMessages && msg.type === "message") {
			if (!document.hasFocus() || !$(target).hasClass("active")) {
				if (options.notification) {
					try {
						pop.play();
					} catch (exception) {
						// On mobile, sounds can not be played without user interaction.
					}
				}
				utils.toggleNotificationMarkers(true);

				if (options.desktopNotifications && Notification.permission === "granted") {
					var title;
					var body;

					if (msg.type === "invite") {
						title = "New channel invite:";
						body = msg.from + " invited you to " + msg.channel;
					} else {
						title = msg.from;
						if (!button.hasClass("query")) {
							title += " (" + button.data("title").trim() + ")";
						}
						if (msg.type === "message") {
							title += " says:";
						}
						body = msg.text.replace(/\x03(?:[0-9]{1,2}(?:,[0-9]{1,2})?)?|[\x00-\x1F]|\x7F/g, "").trim();
					}

					try {
						var notify = new Notification(title, {
							body: body,
							icon: "img/logo-64.png",
							tag: target
						});
						notify.addEventListener("click", function () {
							window.focus();
							button.click();
							this.close();
						});
					} catch (exception) {
						// `new Notification(...)` is not supported and should be silenced.
					}
				}
			}
		}

		if (button.hasClass("active")) {
			return;
		}

		if (!unread) {
			return;
		}

		var badge = button.find(".badge").html(helpers_roundBadgeNumber(unread));

		if (msg.highlight) {
			badge.addClass("highlight");
		}
	});

	chat.on("click", ".show-more-button", function () {
		var self = $(this);
		var lastMessage = self.parent().next(".messages").children(".msg").first();
		var lastMessageId = parseInt(lastMessage[0].id.replace("msg-", ""), 10);
		self.prop("disabled", true);
		socket.emit("more", {
			target: self.data("id"),
			lastId: lastMessageId
		});
	});

	var forms = $("#sign-in, #connect, #change-password");

	windows.on("show", "#sign-in", function () {
		$(this).find("input").each(function () {
			var self = $(this);
			if (self.val() === "") {
				self.focus();
				return false;
			}
		});
	});
	if ($("body").hasClass("public")) {
		$("#connect").one("show", function () {
			var params = URI(document.location.search);
			params = params.search(true);
			// Possible parameters:  name, host, port, password, tls, nick, username, realname, join
			// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/for...in#Iterating_over_own_properties_only
			for (var key in params) {
				if (params.hasOwnProperty(key)) {
					var value = params[key];
					// \W searches for non-word characters
					key = key.replace(/\W/g, "");

					var element = $("#connect input[name='" + key + "']");
					// if the element exists, it isn't disabled, and it isn't hidden
					if (element.length > 0 && !element.is(":disabled") && !element.is(":hidden")) {
						if (element.is(":checkbox")) {
							element.prop("checked", value === "1" || value === "true" ? true : false);
						} else {
							element.val(value);
						}
					}
				}
			}
		});
	}

	forms.on("submit", "form", function (e) {
		e.preventDefault();
		var event = "auth";
		var form = $(this);
		form.find(".btn").attr("disabled", true).end();
		if (form.closest(".window").attr("id") === "connect") {
			event = "conn";
		} else if (form.closest("div").attr("id") === "change-password") {
			event = "change-password";
		}
		var values = {};
		$.each(form.serializeArray(), function (i, obj) {
			if (obj.value !== "") {
				values[obj.name] = obj.value;
			}
		});
		if (values.user) {
			storage.set("user", values.user);
		}
		socket.emit(event, values);
	});

	forms.on("focusin", ".nick", function () {
		// Need to set the first "lastvalue", so it can be used in the below function
		var nick = $(this);
		nick.data("lastvalue", nick.val());
	});

	forms.on("input", ".nick", function () {
		var nick = $(this).val();
		var usernameInput = forms.find(".username");

		// Because this gets called /after/ it has already changed, we need use the previous value
		var lastValue = $(this).data("lastvalue");

		// They were the same before the change, so update the username field
		if (usernameInput.val() === lastValue) {
			usernameInput.val(nick);
		}

		// Store the "previous" value, for next time
		$(this).data("lastvalue", nick);
	});

	(function HotkeysScope() {
		Mousetrap.bind(["pageup", "pagedown"], function (e, key) {
			var container = windows.find(".window.active");

			// Chat windows scroll message container
			if (container.attr("id") === "chat-container") {
				container = container.find(".chan.active .chat");
			}

			container.finish();

			var offset = container.get(0).clientHeight * 0.9;
			var scrollTop = container.scrollTop();

			if (key === "pageup") {
				scrollTop = Math.floor(scrollTop - offset);
			} else {
				scrollTop = Math.ceil(scrollTop + offset);
			}

			container.animate({
				scrollTop: scrollTop
			}, 200);

			return false;
		});

		Mousetrap.bind(["command+up", "command+down", "ctrl+up", "ctrl+down"], function (e, keys) {
			var channels = sidebar.find(".chan");
			var index = channels.index(channels.filter(".active"));
			var direction = keys.split("+").pop();
			switch (direction) {
				case "up":
					// Loop
					var upTarget = (channels.length + (index - 1 + channels.length)) % channels.length;
					channels.eq(upTarget).click();
					break;

				case "down":
					// Loop
					var downTarget = (channels.length + (index + 1 + channels.length)) % channels.length;
					channels.eq(downTarget).click();
					break;
			}
		});

		Mousetrap.bind(["command+shift+l", "ctrl+shift+l"], function (e) {
			if (e.target === input[0]) {
				utils.clear();
				e.preventDefault();
			}
		});

		Mousetrap.bind(["escape"], function () {
			contextMenuContainer.hide();
		});

		var colorsHotkeys = {
			k: "\x03",
			b: "\x02",
			u: "\x1F",
			i: "\x1D",
			o: "\x0F"
		};

		for (var hotkey in colorsHotkeys) {
			Mousetrap.bind(["command+" + hotkey, "ctrl+" + hotkey], function (e) {
				e.preventDefault();

				var cursorPosStart = input.prop("selectionStart");
				var cursorPosEnd = input.prop("selectionEnd");
				var value = input.val();
				var newValue = value.substring(0, cursorPosStart) + colorsHotkeys[e.key];

				if (cursorPosStart === cursorPosEnd) {
					// If no text is selected, insert at cursor
					newValue += value.substring(cursorPosEnd, value.length);
				} else {
					// If text is selected, insert formatting character at start and the end
					newValue += value.substring(cursorPosStart, cursorPosEnd) + colorsHotkeys[e.key] + value.substring(cursorPosEnd, value.length);
				}

				input.val(newValue).get(0).setSelectionRange(cursorPosStart + 1, cursorPosEnd + 1);
			});
		}
	})();

	setInterval(function () {
		chat.find(".chan:not(.active)").each(function () {
			var chan = $(this);
			if (chan.find(".messages .msg").slice(0, -100).remove().length) {
				chan.find(".show-more").addClass("show");

				// Remove date-seperators that would otherwise be "stuck" at the top
				// of the channel
				chan.find(".date-marker-container").each(function () {
					if ($(this).next().hasClass("date-marker-container")) {
						$(this).remove();
					}
				});
			}
		});
	}, 1000 * 10);

	function completeNicks(word) {
		var users = chat.find(".active .users");

		// Lobbies and private chats do not have an user list
		if (!users.length) {
			return [];
		}

		var words = users.data("nicks");

		return $.grep(words, function (w) {
			return !w.toLowerCase().indexOf(word.toLowerCase());
		});
	}

	function completeCommands(word) {
		var words = constants.commands.slice();

		return $.grep(words, function (w) {
			return !w.toLowerCase().indexOf(word.toLowerCase());
		});
	}

	function completeChans(word) {
		var words = [];

		sidebar.find(".chan").each(function () {
			var self = $(this);
			if (!self.hasClass("lobby")) {
				words.push(self.data("title"));
			}
		});

		return $.grep(words, function (w) {
			return !w.toLowerCase().indexOf(word.toLowerCase());
		});
	}

	$(document).on("visibilitychange focus click", function () {
		if (sidebar.find(".highlight").length === 0) {
			utils.toggleNotificationMarkers(false);
		}
	});

	// Compute how many milliseconds are remaining until the next day starts
	function msUntilNextDay() {
		return moment().add(1, "day").startOf("day") - moment();
	}

	// Go through all Today/Yesterday date markers in the DOM and recompute their
	// labels. When done, restart the timer for the next day.
	function updateDateMarkers() {
		$(".date-marker-text[data-label='Today'], .date-marker-text[data-label='Yesterday']").closest(".date-marker-container").each(function () {
			$(this).replaceWith(templates.date_marker({ msgDate: $(this).data("timestamp") }));
		});

		// This should always be 24h later but re-computing exact value just in case
		setTimeout(updateDateMarkers, msUntilNextDay());
	}
	setTimeout(updateDateMarkers, msUntilNextDay());

	// Only start opening socket.io connection after all events have been registered
	socket.open();

	window.addEventListener("popstate", function (e) {
		var state = e.state;

		if (!state) {
			return;
		}

		var clickTarget = state.clickTarget;

		if (clickTarget) {
			$(clickTarget).trigger("click", {
				pushState: false
			});
		}
	});
});

/***/ }),
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */
/***/ (function(module, exports) {

module.exports = {"100":"💯","1234":"🔢","grinning":"😀","grimacing":"😬","grin":"😁","joy":"😂","rofl":"🤣","smiley":"😃","smile":"😄","sweat_smile":"😅","laughing":"😆","innocent":"😇","wink":"😉","blush":"😊","slightly_smiling_face":"🙂","upside_down_face":"🙃","relaxed":"☺️","yum":"😋","relieved":"😌","heart_eyes":"😍","kissing_heart":"😘","kissing":"😗","kissing_smiling_eyes":"😙","kissing_closed_eyes":"😚","stuck_out_tongue_winking_eye":"😜","stuck_out_tongue_closed_eyes":"😝","stuck_out_tongue":"😛","money_mouth_face":"🤑","nerd_face":"🤓","sunglasses":"😎","clown_face":"🤡","cowboy_hat_face":"🤠","hugs":"🤗","smirk":"😏","no_mouth":"😶","neutral_face":"😐","expressionless":"😑","unamused":"😒","roll_eyes":"🙄","thinking":"🤔","lying_face":"🤥","flushed":"😳","disappointed":"😞","worried":"😟","angry":"😠","rage":"😡","pensive":"😔","confused":"😕","slightly_frowning_face":"🙁","frowning_face":"☹","persevere":"😣","confounded":"😖","tired_face":"😫","weary":"😩","triumph":"😤","open_mouth":"😮","scream":"😱","fearful":"😨","cold_sweat":"😰","hushed":"😯","frowning":"😦","anguished":"😧","cry":"😢","disappointed_relieved":"😥","drooling_face":"🤤","sleepy":"😪","sweat":"😓","sob":"😭","dizzy_face":"😵","astonished":"😲","zipper_mouth_face":"🤐","nauseated_face":"🤢","sneezing_face":"🤧","mask":"😷","face_with_thermometer":"🤒","face_with_head_bandage":"🤕","sleeping":"😴","zzz":"💤","poop":"💩","smiling_imp":"😈","imp":"👿","japanese_ogre":"👹","japanese_goblin":"👺","skull":"💀","ghost":"👻","alien":"👽","robot":"🤖","smiley_cat":"😺","smile_cat":"😸","joy_cat":"😹","heart_eyes_cat":"😻","smirk_cat":"😼","kissing_cat":"😽","scream_cat":"🙀","crying_cat_face":"😿","pouting_cat":"😾","raised_hands":"🙌","clap":"👏","wave":"👋","call_me_hand":"🤙","+1":"👍","-1":"👎","facepunch":"👊","fist":"✊","fist_left":"🤛","fist_right":"🤜","v":"✌","ok_hand":"👌","raised_hand":"✋","raised_back_of_hand":"🤚","open_hands":"👐","muscle":"💪","pray":"🙏","handshake":"🤝","point_up":"☝","point_up_2":"👆","point_down":"👇","point_left":"👈","point_right":"👉","fu":"🖕","raised_hand_with_fingers_splayed":"🖐","metal":"🤘","crossed_fingers":"🤞","vulcan_salute":"🖖","writing_hand":"✍","selfie":"🤳","nail_care":"💅","lips":"👄","tongue":"👅","ear":"👂","nose":"👃","eye":"👁","eyes":"👀","bust_in_silhouette":"👤","busts_in_silhouette":"👥","speaking_head":"🗣","baby":"👶","boy":"👦","girl":"👧","man":"👨","woman":"👩","blonde_woman":"👱‍♀️","blonde_man":"👱","older_man":"👴","older_woman":"👵","man_with_gua_pi_mao":"👲","woman_with_turban":"👳‍♀️","man_with_turban":"👳","policewoman":"👮‍♀️","policeman":"👮","construction_worker_woman":"👷‍♀️","construction_worker_man":"👷","guardswoman":"💂‍♀️","guardsman":"💂","female_detective":"🕵️‍♀️","male_detective":"🕵","woman_health_worker":"👩‍⚕️","man_health_worker":"👨‍⚕️","woman_farmer":"👩‍🌾","man_farmer":"👨‍🌾","woman_cook":"👩‍🍳","man_cook":"👨‍🍳","woman_student":"👩‍🎓","man_student":"👨‍🎓","woman_singer":"👩‍🎤","man_singer":"👨‍🎤","woman_teacher":"👩‍🏫","man_teacher":"👨‍🏫","woman_factory_worker":"👩‍🏭","man_factory_worker":"👨‍🏭","woman_technologist":"👩‍💻","man_technologist":"👨‍💻","woman_office_worker":"👩‍💼","man_office_worker":"👨‍💼","woman_mechanic":"👩‍🔧","man_mechanic":"👨‍🔧","woman_scientist":"👩‍🔬","man_scientist":"👨‍🔬","woman_artist":"👩‍🎨","man_artist":"👨‍🎨","woman_firefighter":"👩‍🚒","man_firefighter":"👨‍🚒","woman_pilot":"👩‍✈️","man_pilot":"👨‍✈️","woman_astronaut":"👩‍🚀","man_astronaut":"👨‍🚀","woman_judge":"👩‍⚖️","man_judge":"👨‍⚖️","mrs_claus":"🤶","santa":"🎅","angel":"👼","pregnant_woman":"🤰","princess":"👸","prince":"🤴","bride_with_veil":"👰","man_in_tuxedo":"🤵","running_woman":"🏃‍♀️","running_man":"🏃","walking_woman":"🚶‍♀️","walking_man":"🚶","dancer":"💃","man_dancing":"🕺","dancing_women":"👯","dancing_men":"👯‍♂️","couple":"👫","two_men_holding_hands":"👬","two_women_holding_hands":"👭","bowing_woman":"🙇‍♀️","bowing_man":"🙇","man_facepalming":"🤦","woman_facepalming":"🤦‍♀️","woman_shrugging":"🤷","man_shrugging":"🤷‍♂️","tipping_hand_woman":"💁","tipping_hand_man":"💁‍♂️","no_good_woman":"🙅","no_good_man":"🙅‍♂️","ok_woman":"🙆","ok_man":"🙆‍♂️","raising_hand_woman":"🙋","raising_hand_man":"🙋‍♂️","pouting_woman":"🙎","pouting_man":"🙎‍♂️","frowning_woman":"🙍","frowning_man":"🙍‍♂️","haircut_woman":"💇","haircut_man":"💇‍♂️","massage_woman":"💆","massage_man":"💆‍♂️","couple_with_heart_woman_man":"💑","couple_with_heart_woman_woman":"👩‍❤️‍👩","couple_with_heart_man_man":"👨‍❤️‍👨","couplekiss_man_woman":"💏","couplekiss_woman_woman":"👩‍❤️‍💋‍👩","couplekiss_man_man":"👨‍❤️‍💋‍👨","family_man_woman_boy":"👪","family_man_woman_girl":"👨‍👩‍👧","family_man_woman_girl_boy":"👨‍👩‍👧‍👦","family_man_woman_boy_boy":"👨‍👩‍👦‍👦","family_man_woman_girl_girl":"👨‍👩‍👧‍👧","family_woman_woman_boy":"👩‍👩‍👦","family_woman_woman_girl":"👩‍👩‍👧","family_woman_woman_girl_boy":"👩‍👩‍👧‍👦","family_woman_woman_boy_boy":"👩‍👩‍👦‍👦","family_woman_woman_girl_girl":"👩‍👩‍👧‍👧","family_man_man_boy":"👨‍👨‍👦","family_man_man_girl":"👨‍👨‍👧","family_man_man_girl_boy":"👨‍👨‍👧‍👦","family_man_man_boy_boy":"👨‍👨‍👦‍👦","family_man_man_girl_girl":"👨‍👨‍👧‍👧","family_woman_boy":"👩‍👦","family_woman_girl":"👩‍👧","family_woman_girl_boy":"👩‍👧‍👦","family_woman_boy_boy":"👩‍👦‍👦","family_woman_girl_girl":"👩‍👧‍👧","family_man_boy":"👨‍👦","family_man_girl":"👨‍👧","family_man_girl_boy":"👨‍👧‍👦","family_man_boy_boy":"👨‍👦‍👦","family_man_girl_girl":"👨‍👧‍👧","womans_clothes":"👚","tshirt":"👕","jeans":"👖","necktie":"👔","dress":"👗","bikini":"👙","kimono":"👘","lipstick":"💄","kiss":"💋","footprints":"👣","high_heel":"👠","sandal":"👡","boot":"👢","mans_shoe":"👞","athletic_shoe":"👟","womans_hat":"👒","tophat":"🎩","rescue_worker_helmet":"⛑","mortar_board":"🎓","crown":"👑","school_satchel":"🎒","pouch":"👝","purse":"👛","handbag":"👜","briefcase":"💼","eyeglasses":"👓","dark_sunglasses":"🕶","ring":"💍","closed_umbrella":"🌂","dog":"🐶","cat":"🐱","mouse":"🐭","hamster":"🐹","rabbit":"🐰","fox_face":"🦊","bear":"🐻","panda_face":"🐼","koala":"🐨","tiger":"🐯","lion":"🦁","cow":"🐮","pig":"🐷","pig_nose":"🐽","frog":"🐸","squid":"🦑","octopus":"🐙","shrimp":"🦐","monkey_face":"🐵","gorilla":"🦍","see_no_evil":"🙈","hear_no_evil":"🙉","speak_no_evil":"🙊","monkey":"🐒","chicken":"🐔","penguin":"🐧","bird":"🐦","baby_chick":"🐤","hatching_chick":"🐣","hatched_chick":"🐥","duck":"🦆","eagle":"🦅","owl":"🦉","bat":"🦇","wolf":"🐺","boar":"🐗","horse":"🐴","unicorn":"🦄","honeybee":"🐝","bug":"🐛","butterfly":"🦋","snail":"🐌","beetle":"🐞","ant":"🐜","spider":"🕷","scorpion":"🦂","crab":"🦀","snake":"🐍","lizard":"🦎","turtle":"🐢","tropical_fish":"🐠","fish":"🐟","blowfish":"🐡","dolphin":"🐬","shark":"🦈","whale":"🐳","whale2":"🐋","crocodile":"🐊","leopard":"🐆","tiger2":"🐅","water_buffalo":"🐃","ox":"🐂","cow2":"🐄","deer":"🦌","dromedary_camel":"🐪","camel":"🐫","elephant":"🐘","rhinoceros":"🦏","goat":"🐐","ram":"🐏","sheep":"🐑","racehorse":"🐎","pig2":"🐖","rat":"🐀","mouse2":"🐁","rooster":"🐓","turkey":"🦃","dove":"🕊","dog2":"🐕","poodle":"🐩","cat2":"🐈","rabbit2":"🐇","chipmunk":"🐿","paw_prints":"🐾","dragon":"🐉","dragon_face":"🐲","cactus":"🌵","christmas_tree":"🎄","evergreen_tree":"🌲","deciduous_tree":"🌳","palm_tree":"🌴","seedling":"🌱","herb":"🌿","shamrock":"☘","four_leaf_clover":"🍀","bamboo":"🎍","tanabata_tree":"🎋","leaves":"🍃","fallen_leaf":"🍂","maple_leaf":"🍁","ear_of_rice":"🌾","hibiscus":"🌺","sunflower":"🌻","rose":"🌹","wilted_flower":"🥀","tulip":"🌷","blossom":"🌼","cherry_blossom":"🌸","bouquet":"💐","mushroom":"🍄","chestnut":"🌰","jack_o_lantern":"🎃","shell":"🐚","spider_web":"🕸","earth_americas":"🌎","earth_africa":"🌍","earth_asia":"🌏","full_moon":"🌕","waning_gibbous_moon":"🌖","last_quarter_moon":"🌗","waning_crescent_moon":"🌘","new_moon":"🌑","waxing_crescent_moon":"🌒","first_quarter_moon":"🌓","waxing_gibbous_moon":"🌔","new_moon_with_face":"🌚","full_moon_with_face":"🌝","first_quarter_moon_with_face":"🌛","last_quarter_moon_with_face":"🌜","sun_with_face":"🌞","crescent_moon":"🌙","star":"⭐","star2":"🌟","dizzy":"💫","sparkles":"✨","comet":"☄","sunny":"☀️","sun_behind_small_cloud":"🌤","partly_sunny":"⛅","sun_behind_large_cloud":"🌥","sun_behind_rain_cloud":"🌦","cloud":"☁️","cloud_with_rain":"🌧","cloud_with_lightning_and_rain":"⛈","cloud_with_lightning":"🌩","zap":"⚡","fire":"🔥","boom":"💥","snowflake":"❄️","cloud_with_snow":"🌨","snowman":"⛄","snowman_with_snow":"☃","wind_face":"🌬","dash":"💨","tornado":"🌪","fog":"🌫","open_umbrella":"☂","umbrella":"☔","droplet":"💧","sweat_drops":"💦","ocean":"🌊","green_apple":"🍏","apple":"🍎","pear":"🍐","tangerine":"🍊","lemon":"🍋","banana":"🍌","watermelon":"🍉","grapes":"🍇","strawberry":"🍓","melon":"🍈","cherries":"🍒","peach":"🍑","pineapple":"🍍","kiwi_fruit":"🥝","avocado":"🥑","tomato":"🍅","eggplant":"🍆","cucumber":"🥒","carrot":"🥕","hot_pepper":"🌶","potato":"🥔","corn":"🌽","sweet_potato":"🍠","peanuts":"🥜","honey_pot":"🍯","croissant":"🥐","bread":"🍞","baguette_bread":"🥖","cheese":"🧀","egg":"🥚","bacon":"🥓","pancakes":"🥞","poultry_leg":"🍗","meat_on_bone":"🍖","fried_shrimp":"🍤","fried_egg":"🍳","hamburger":"🍔","fries":"🍟","stuffed_flatbread":"🥙","hotdog":"🌭","pizza":"🍕","spaghetti":"🍝","taco":"🌮","burrito":"🌯","green_salad":"🥗","shallow_pan_of_food":"🥘","ramen":"🍜","stew":"🍲","fish_cake":"🍥","sushi":"🍣","bento":"🍱","curry":"🍛","rice_ball":"🍙","rice":"🍚","rice_cracker":"🍘","oden":"🍢","dango":"🍡","shaved_ice":"🍧","ice_cream":"🍨","icecream":"🍦","cake":"🍰","birthday":"🎂","custard":"🍮","candy":"🍬","lollipop":"🍭","chocolate_bar":"🍫","popcorn":"🍿","doughnut":"🍩","cookie":"🍪","milk_glass":"🥛","beer":"🍺","beers":"🍻","clinking_glasses":"🥂","wine_glass":"🍷","tumbler_glass":"🥃","cocktail":"🍸","tropical_drink":"🍹","champagne":"🍾","sake":"🍶","tea":"🍵","coffee":"☕","baby_bottle":"🍼","spoon":"🥄","fork_and_knife":"🍴","plate_with_cutlery":"🍽","soccer":"⚽","basketball":"🏀","football":"🏈","baseball":"⚾","tennis":"🎾","volleyball":"🏐","rugby_football":"🏉","8ball":"🎱","golf":"⛳","golfing_woman":"🏌️‍♀️","golfing_man":"🏌","ping_pong":"🏓","badminton":"🏸","goal_net":"🥅","ice_hockey":"🏒","field_hockey":"🏑","cricket":"🏏","ski":"🎿","skier":"⛷","snowboarder":"🏂","person_fencing":"🤺","women_wrestling":"🤼‍♀️","men_wrestling":"🤼‍♂️","woman_cartwheeling":"🤸‍♀️","man_cartwheeling":"🤸‍♂️","woman_playing_handball":"🤾‍♀️","man_playing_handball":"🤾‍♂️","ice_skate":"⛸","bow_and_arrow":"🏹","fishing_pole_and_fish":"🎣","boxing_glove":"🥊","martial_arts_uniform":"🥋","rowing_woman":"🚣‍♀️","rowing_man":"🚣","swimming_woman":"🏊‍♀️","swimming_man":"🏊","woman_playing_water_polo":"🤽‍♀️","man_playing_water_polo":"🤽‍♂️","surfing_woman":"🏄‍♀️","surfing_man":"🏄","bath":"🛀","basketball_woman":"⛹️‍♀️","basketball_man":"⛹","weight_lifting_woman":"🏋️‍♀️","weight_lifting_man":"🏋","biking_woman":"🚴‍♀️","biking_man":"🚴","mountain_biking_woman":"🚵‍♀️","mountain_biking_man":"🚵","horse_racing":"🏇","business_suit_levitating":"🕴","trophy":"🏆","running_shirt_with_sash":"🎽","medal_sports":"🏅","medal_military":"🎖","1st_place_medal":"🥇","2nd_place_medal":"🥈","3rd_place_medal":"🥉","reminder_ribbon":"🎗","rosette":"🏵","ticket":"🎫","tickets":"🎟","performing_arts":"🎭","art":"🎨","circus_tent":"🎪","woman_juggling":"🤹‍♀️","man_juggling":"🤹‍♂️","microphone":"🎤","headphones":"🎧","musical_score":"🎼","musical_keyboard":"🎹","drum":"🥁","saxophone":"🎷","trumpet":"🎺","guitar":"🎸","violin":"🎻","clapper":"🎬","video_game":"🎮","space_invader":"👾","dart":"🎯","game_die":"🎲","slot_machine":"🎰","bowling":"🎳","red_car":"🚗","taxi":"🚕","blue_car":"🚙","bus":"🚌","trolleybus":"🚎","racing_car":"🏎","police_car":"🚓","ambulance":"🚑","fire_engine":"🚒","minibus":"🚐","truck":"🚚","articulated_lorry":"🚛","tractor":"🚜","kick_scooter":"🛴","motorcycle":"🏍","bike":"🚲","motor_scooter":"🛵","rotating_light":"🚨","oncoming_police_car":"🚔","oncoming_bus":"🚍","oncoming_automobile":"🚘","oncoming_taxi":"🚖","aerial_tramway":"🚡","mountain_cableway":"🚠","suspension_railway":"🚟","railway_car":"🚃","train":"🚋","monorail":"🚝","bullettrain_side":"🚄","bullettrain_front":"🚅","light_rail":"🚈","mountain_railway":"🚞","steam_locomotive":"🚂","train2":"🚆","metro":"🚇","tram":"🚊","station":"🚉","helicopter":"🚁","small_airplane":"🛩","airplane":"✈️","flight_departure":"🛫","flight_arrival":"🛬","sailboat":"⛵","motor_boat":"🛥","speedboat":"🚤","ferry":"⛴","passenger_ship":"🛳","rocket":"🚀","artificial_satellite":"🛰","seat":"💺","canoe":"🛶","anchor":"⚓","construction":"🚧","fuelpump":"⛽","busstop":"🚏","vertical_traffic_light":"🚦","traffic_light":"🚥","checkered_flag":"🏁","ship":"🚢","ferris_wheel":"🎡","roller_coaster":"🎢","carousel_horse":"🎠","building_construction":"🏗","foggy":"🌁","tokyo_tower":"🗼","factory":"🏭","fountain":"⛲","rice_scene":"🎑","mountain":"⛰","mountain_snow":"🏔","mount_fuji":"🗻","volcano":"🌋","japan":"🗾","camping":"🏕","tent":"⛺","national_park":"🏞","motorway":"🛣","railway_track":"🛤","sunrise":"🌅","sunrise_over_mountains":"🌄","desert":"🏜","beach_umbrella":"🏖","desert_island":"🏝","city_sunrise":"🌇","city_sunset":"🌆","cityscape":"🏙","night_with_stars":"🌃","bridge_at_night":"🌉","milky_way":"🌌","stars":"🌠","sparkler":"🎇","fireworks":"🎆","rainbow":"🌈","houses":"🏘","european_castle":"🏰","japanese_castle":"🏯","stadium":"🏟","statue_of_liberty":"🗽","house":"🏠","house_with_garden":"🏡","derelict_house":"🏚","office":"🏢","department_store":"🏬","post_office":"🏣","european_post_office":"🏤","hospital":"🏥","bank":"🏦","hotel":"🏨","convenience_store":"🏪","school":"🏫","love_hotel":"🏩","wedding":"💒","classical_building":"🏛","church":"⛪","mosque":"🕌","synagogue":"🕍","kaaba":"🕋","shinto_shrine":"⛩","watch":"⌚","iphone":"📱","calling":"📲","computer":"💻","keyboard":"⌨","desktop_computer":"🖥","printer":"🖨","computer_mouse":"🖱","trackball":"🖲","joystick":"🕹","clamp":"🗜","minidisc":"💽","floppy_disk":"💾","cd":"💿","dvd":"📀","vhs":"📼","camera":"📷","camera_flash":"📸","video_camera":"📹","movie_camera":"🎥","film_projector":"📽","film_strip":"🎞","telephone_receiver":"📞","phone":"☎️","pager":"📟","fax":"📠","tv":"📺","radio":"📻","studio_microphone":"🎙","level_slider":"🎚","control_knobs":"🎛","stopwatch":"⏱","timer_clock":"⏲","alarm_clock":"⏰","mantelpiece_clock":"🕰","hourglass_flowing_sand":"⏳","hourglass":"⌛","satellite":"📡","battery":"🔋","electric_plug":"🔌","bulb":"💡","flashlight":"🔦","candle":"🕯","wastebasket":"🗑","oil_drum":"🛢","money_with_wings":"💸","dollar":"💵","yen":"💴","euro":"💶","pound":"💷","moneybag":"💰","credit_card":"💳","gem":"💎","balance_scale":"⚖","wrench":"🔧","hammer":"🔨","hammer_and_pick":"⚒","hammer_and_wrench":"🛠","pick":"⛏","nut_and_bolt":"🔩","gear":"⚙","chains":"⛓","gun":"🔫","bomb":"💣","hocho":"🔪","dagger":"🗡","crossed_swords":"⚔","shield":"🛡","smoking":"🚬","skull_and_crossbones":"☠","coffin":"⚰","funeral_urn":"⚱","amphora":"🏺","crystal_ball":"🔮","prayer_beads":"📿","barber":"💈","alembic":"⚗","telescope":"🔭","microscope":"🔬","hole":"🕳","pill":"💊","syringe":"💉","thermometer":"🌡","label":"🏷","bookmark":"🔖","toilet":"🚽","shower":"🚿","bathtub":"🛁","key":"🔑","old_key":"🗝","couch_and_lamp":"🛋","sleeping_bed":"🛌","bed":"🛏","door":"🚪","bellhop_bell":"🛎","framed_picture":"🖼","world_map":"🗺","parasol_on_ground":"⛱","moyai":"🗿","shopping":"🛍","shopping_cart":"🛒","balloon":"🎈","flags":"🎏","ribbon":"🎀","gift":"🎁","confetti_ball":"🎊","tada":"🎉","dolls":"🎎","wind_chime":"🎐","crossed_flags":"🎌","izakaya_lantern":"🏮","email":"✉️","envelope_with_arrow":"📩","incoming_envelope":"📨","e-mail":"📧","love_letter":"💌","postbox":"📮","mailbox_closed":"📪","mailbox":"📫","mailbox_with_mail":"📬","mailbox_with_no_mail":"📭","package":"📦","postal_horn":"📯","inbox_tray":"📥","outbox_tray":"📤","scroll":"📜","page_with_curl":"📃","bookmark_tabs":"📑","bar_chart":"📊","chart_with_upwards_trend":"📈","chart_with_downwards_trend":"📉","page_facing_up":"📄","date":"📅","calendar":"📆","spiral_calendar":"🗓","card_index":"📇","card_file_box":"🗃","ballot_box":"🗳","file_cabinet":"🗄","clipboard":"📋","spiral_notepad":"🗒","file_folder":"📁","open_file_folder":"📂","card_index_dividers":"🗂","newspaper_roll":"🗞","newspaper":"📰","notebook":"📓","closed_book":"📕","green_book":"📗","blue_book":"📘","orange_book":"📙","notebook_with_decorative_cover":"📔","ledger":"📒","books":"📚","open_book":"📖","link":"🔗","paperclip":"📎","paperclips":"🖇","scissors":"✂️","triangular_ruler":"📐","straight_ruler":"📏","pushpin":"📌","round_pushpin":"📍","triangular_flag_on_post":"🚩","white_flag":"🏳","black_flag":"🏴","rainbow_flag":"🏳️‍🌈","closed_lock_with_key":"🔐","lock":"🔒","unlock":"🔓","lock_with_ink_pen":"🔏","pen":"🖊","fountain_pen":"🖋","black_nib":"✒️","memo":"📝","pencil2":"✏️","crayon":"🖍","paintbrush":"🖌","mag":"🔍","mag_right":"🔎","heart":"❤️","yellow_heart":"💛","green_heart":"💚","blue_heart":"💙","purple_heart":"💜","black_heart":"🖤","broken_heart":"💔","heavy_heart_exclamation":"❣","two_hearts":"💕","revolving_hearts":"💞","heartbeat":"💓","heartpulse":"💗","sparkling_heart":"💖","cupid":"💘","gift_heart":"💝","heart_decoration":"💟","peace_symbol":"☮","latin_cross":"✝","star_and_crescent":"☪","om":"🕉","wheel_of_dharma":"☸","star_of_david":"✡","six_pointed_star":"🔯","menorah":"🕎","yin_yang":"☯","orthodox_cross":"☦","place_of_worship":"🛐","ophiuchus":"⛎","aries":"♈","taurus":"♉","gemini":"♊","cancer":"♋","leo":"♌","virgo":"♍","libra":"♎","scorpius":"♏","sagittarius":"♐","capricorn":"♑","aquarius":"♒","pisces":"♓","id":"🆔","atom_symbol":"⚛","u7a7a":"🈳","u5272":"🈹","radioactive":"☢","biohazard":"☣","mobile_phone_off":"📴","vibration_mode":"📳","u6709":"🈶","u7121":"🈚","u7533":"🈸","u55b6":"🈺","u6708":"🈷️","eight_pointed_black_star":"✴️","vs":"🆚","accept":"🉑","white_flower":"💮","ideograph_advantage":"🉐","secret":"㊙️","congratulations":"㊗️","u5408":"🈴","u6e80":"🈵","u7981":"🈲","a":"🅰️","b":"🅱️","ab":"🆎","cl":"🆑","o2":"🅾️","sos":"🆘","no_entry":"⛔","name_badge":"📛","no_entry_sign":"🚫","x":"❌","o":"⭕","stop_sign":"🛑","anger":"💢","hotsprings":"♨️","no_pedestrians":"🚷","do_not_litter":"🚯","no_bicycles":"🚳","non-potable_water":"🚱","underage":"🔞","no_mobile_phones":"📵","exclamation":"❗","grey_exclamation":"❕","question":"❓","grey_question":"❔","bangbang":"‼️","interrobang":"⁉️","low_brightness":"🔅","high_brightness":"🔆","trident":"🔱","fleur_de_lis":"⚜","part_alternation_mark":"〽️","warning":"⚠️","children_crossing":"🚸","beginner":"🔰","recycle":"♻️","u6307":"🈯","chart":"💹","sparkle":"❇️","eight_spoked_asterisk":"✳️","negative_squared_cross_mark":"❎","white_check_mark":"✅","diamond_shape_with_a_dot_inside":"💠","cyclone":"🌀","loop":"➿","globe_with_meridians":"🌐","m":"Ⓜ️","atm":"🏧","sa":"🈂️","passport_control":"🛂","customs":"🛃","baggage_claim":"🛄","left_luggage":"🛅","wheelchair":"♿","no_smoking":"🚭","wc":"🚾","parking":"🅿️","potable_water":"🚰","mens":"🚹","womens":"🚺","baby_symbol":"🚼","restroom":"🚻","put_litter_in_its_place":"🚮","cinema":"🎦","signal_strength":"📶","koko":"🈁","ng":"🆖","ok":"🆗","up":"🆙","cool":"🆒","new":"🆕","free":"🆓","zero":"0️⃣","one":"1️⃣","two":"2️⃣","three":"3️⃣","four":"4️⃣","five":"5️⃣","six":"6️⃣","seven":"7️⃣","eight":"8️⃣","nine":"9️⃣","keycap_ten":"🔟","asterisk":"*⃣","arrow_forward":"▶️","pause_button":"⏸","next_track_button":"⏭","stop_button":"⏹","record_button":"⏺","play_or_pause_button":"⏯","previous_track_button":"⏮","fast_forward":"⏩","rewind":"⏪","twisted_rightwards_arrows":"🔀","repeat":"🔁","repeat_one":"🔂","arrow_backward":"◀️","arrow_up_small":"🔼","arrow_down_small":"🔽","arrow_double_up":"⏫","arrow_double_down":"⏬","arrow_right":"➡️","arrow_left":"⬅️","arrow_up":"⬆️","arrow_down":"⬇️","arrow_upper_right":"↗️","arrow_lower_right":"↘️","arrow_lower_left":"↙️","arrow_upper_left":"↖️","arrow_up_down":"↕️","left_right_arrow":"↔️","arrows_counterclockwise":"🔄","arrow_right_hook":"↪️","leftwards_arrow_with_hook":"↩️","arrow_heading_up":"⤴️","arrow_heading_down":"⤵️","hash":"#️⃣","information_source":"ℹ️","abc":"🔤","abcd":"🔡","capital_abcd":"🔠","symbols":"🔣","musical_note":"🎵","notes":"🎶","wavy_dash":"〰️","curly_loop":"➰","heavy_check_mark":"✔️","arrows_clockwise":"🔃","heavy_plus_sign":"➕","heavy_minus_sign":"➖","heavy_division_sign":"➗","heavy_multiplication_x":"✖️","heavy_dollar_sign":"💲","currency_exchange":"💱","copyright":"©️","registered":"®️","tm":"™️","end":"🔚","back":"🔙","on":"🔛","top":"🔝","soon":"🔜","ballot_box_with_check":"☑️","radio_button":"🔘","white_circle":"⚪","black_circle":"⚫","red_circle":"🔴","large_blue_circle":"🔵","small_orange_diamond":"🔸","small_blue_diamond":"🔹","large_orange_diamond":"🔶","large_blue_diamond":"🔷","small_red_triangle":"🔺","black_small_square":"▪️","white_small_square":"▫️","black_large_square":"⬛","white_large_square":"⬜","small_red_triangle_down":"🔻","black_medium_square":"◼️","white_medium_square":"◻️","black_medium_small_square":"◾","white_medium_small_square":"◽","black_square_button":"🔲","white_square_button":"🔳","speaker":"🔈","sound":"🔉","loud_sound":"🔊","mute":"🔇","mega":"📣","loudspeaker":"📢","bell":"🔔","no_bell":"🔕","black_joker":"🃏","mahjong":"🀄","spades":"♠️","clubs":"♣️","hearts":"♥️","diamonds":"♦️","flower_playing_cards":"🎴","thought_balloon":"💭","right_anger_bubble":"🗯","speech_balloon":"💬","left_speech_bubble":"🗨","clock1":"🕐","clock2":"🕑","clock3":"🕒","clock4":"🕓","clock5":"🕔","clock6":"🕕","clock7":"🕖","clock8":"🕗","clock9":"🕘","clock10":"🕙","clock11":"🕚","clock12":"🕛","clock130":"🕜","clock230":"🕝","clock330":"🕞","clock430":"🕟","clock530":"🕠","clock630":"🕡","clock730":"🕢","clock830":"🕣","clock930":"🕤","clock1030":"🕥","clock1130":"🕦","clock1230":"🕧","afghanistan":"🇦🇫","aland_islands":"🇦🇽","albania":"🇦🇱","algeria":"🇩🇿","american_samoa":"🇦🇸","andorra":"🇦🇩","angola":"🇦🇴","anguilla":"🇦🇮","antarctica":"🇦🇶","antigua_barbuda":"🇦🇬","argentina":"🇦🇷","armenia":"🇦🇲","aruba":"🇦🇼","australia":"🇦🇺","austria":"🇦🇹","azerbaijan":"🇦🇿","bahamas":"🇧🇸","bahrain":"🇧🇭","bangladesh":"🇧🇩","barbados":"🇧🇧","belarus":"🇧🇾","belgium":"🇧🇪","belize":"🇧🇿","benin":"🇧🇯","bermuda":"🇧🇲","bhutan":"🇧🇹","bolivia":"🇧🇴","caribbean_netherlands":"🇧🇶","bosnia_herzegovina":"🇧🇦","botswana":"🇧🇼","brazil":"🇧🇷","british_indian_ocean_territory":"🇮🇴","british_virgin_islands":"🇻🇬","brunei":"🇧🇳","bulgaria":"🇧🇬","burkina_faso":"🇧🇫","burundi":"🇧🇮","cape_verde":"🇨🇻","cambodia":"🇰🇭","cameroon":"🇨🇲","canada":"🇨🇦","canary_islands":"🇮🇨","cayman_islands":"🇰🇾","central_african_republic":"🇨🇫","chad":"🇹🇩","chile":"🇨🇱","cn":"🇨🇳","christmas_island":"🇨🇽","cocos_islands":"🇨🇨","colombia":"🇨🇴","comoros":"🇰🇲","congo_brazzaville":"🇨🇬","congo_kinshasa":"🇨🇩","cook_islands":"🇨🇰","costa_rica":"🇨🇷","croatia":"🇭🇷","cuba":"🇨🇺","curacao":"🇨🇼","cyprus":"🇨🇾","czech_republic":"🇨🇿","denmark":"🇩🇰","djibouti":"🇩🇯","dominica":"🇩🇲","dominican_republic":"🇩🇴","ecuador":"🇪🇨","egypt":"🇪🇬","el_salvador":"🇸🇻","equatorial_guinea":"🇬🇶","eritrea":"🇪🇷","estonia":"🇪🇪","ethiopia":"🇪🇹","eu":"🇪🇺","falkland_islands":"🇫🇰","faroe_islands":"🇫🇴","fiji":"🇫🇯","finland":"🇫🇮","fr":"🇫🇷","french_guiana":"🇬🇫","french_polynesia":"🇵🇫","french_southern_territories":"🇹🇫","gabon":"🇬🇦","gambia":"🇬🇲","georgia":"🇬🇪","de":"🇩🇪","ghana":"🇬🇭","gibraltar":"🇬🇮","greece":"🇬🇷","greenland":"🇬🇱","grenada":"🇬🇩","guadeloupe":"🇬🇵","guam":"🇬🇺","guatemala":"🇬🇹","guernsey":"🇬🇬","guinea":"🇬🇳","guinea_bissau":"🇬🇼","guyana":"🇬🇾","haiti":"🇭🇹","honduras":"🇭🇳","hong_kong":"🇭🇰","hungary":"🇭🇺","iceland":"🇮🇸","india":"🇮🇳","indonesia":"🇮🇩","iran":"🇮🇷","iraq":"🇮🇶","ireland":"🇮🇪","isle_of_man":"🇮🇲","israel":"🇮🇱","it":"🇮🇹","cote_divoire":"🇨🇮","jamaica":"🇯🇲","jp":"🇯🇵","jersey":"🇯🇪","jordan":"🇯🇴","kazakhstan":"🇰🇿","kenya":"🇰🇪","kiribati":"🇰🇮","kosovo":"🇽🇰","kuwait":"🇰🇼","kyrgyzstan":"🇰🇬","laos":"🇱🇦","latvia":"🇱🇻","lebanon":"🇱🇧","lesotho":"🇱🇸","liberia":"🇱🇷","libya":"🇱🇾","liechtenstein":"🇱🇮","lithuania":"🇱🇹","luxembourg":"🇱🇺","macau":"🇲🇴","macedonia":"🇲🇰","madagascar":"🇲🇬","malawi":"🇲🇼","malaysia":"🇲🇾","maldives":"🇲🇻","mali":"🇲🇱","malta":"🇲🇹","marshall_islands":"🇲🇭","martinique":"🇲🇶","mauritania":"🇲🇷","mauritius":"🇲🇺","mayotte":"🇾🇹","mexico":"🇲🇽","micronesia":"🇫🇲","moldova":"🇲🇩","monaco":"🇲🇨","mongolia":"🇲🇳","montenegro":"🇲🇪","montserrat":"🇲🇸","morocco":"🇲🇦","mozambique":"🇲🇿","myanmar":"🇲🇲","namibia":"🇳🇦","nauru":"🇳🇷","nepal":"🇳🇵","netherlands":"🇳🇱","new_caledonia":"🇳🇨","new_zealand":"🇳🇿","nicaragua":"🇳🇮","niger":"🇳🇪","nigeria":"🇳🇬","niue":"🇳🇺","norfolk_island":"🇳🇫","northern_mariana_islands":"🇲🇵","north_korea":"🇰🇵","norway":"🇳🇴","oman":"🇴🇲","pakistan":"🇵🇰","palau":"🇵🇼","palestinian_territories":"🇵🇸","panama":"🇵🇦","papua_new_guinea":"🇵🇬","paraguay":"🇵🇾","peru":"🇵🇪","philippines":"🇵🇭","pitcairn_islands":"🇵🇳","poland":"🇵🇱","portugal":"🇵🇹","puerto_rico":"🇵🇷","qatar":"🇶🇦","reunion":"🇷🇪","romania":"🇷🇴","ru":"🇷🇺","rwanda":"🇷🇼","st_barthelemy":"🇧🇱","st_helena":"🇸🇭","st_kitts_nevis":"🇰🇳","st_lucia":"🇱🇨","st_pierre_miquelon":"🇵🇲","st_vincent_grenadines":"🇻🇨","samoa":"🇼🇸","san_marino":"🇸🇲","sao_tome_principe":"🇸🇹","saudi_arabia":"🇸🇦","senegal":"🇸🇳","serbia":"🇷🇸","seychelles":"🇸🇨","sierra_leone":"🇸🇱","singapore":"🇸🇬","sint_maarten":"🇸🇽","slovakia":"🇸🇰","slovenia":"🇸🇮","solomon_islands":"🇸🇧","somalia":"🇸🇴","south_africa":"🇿🇦","south_georgia_south_sandwich_islands":"🇬🇸","kr":"🇰🇷","south_sudan":"🇸🇸","es":"🇪🇸","sri_lanka":"🇱🇰","sudan":"🇸🇩","suriname":"🇸🇷","swaziland":"🇸🇿","sweden":"🇸🇪","switzerland":"🇨🇭","syria":"🇸🇾","taiwan":"🇹🇼","tajikistan":"🇹🇯","tanzania":"🇹🇿","thailand":"🇹🇭","timor_leste":"🇹🇱","togo":"🇹🇬","tokelau":"🇹🇰","tonga":"🇹🇴","trinidad_tobago":"🇹🇹","tunisia":"🇹🇳","tr":"🇹🇷","turkmenistan":"🇹🇲","turks_caicos_islands":"🇹🇨","tuvalu":"🇹🇻","uganda":"🇺🇬","ukraine":"🇺🇦","united_arab_emirates":"🇦🇪","uk":"🇬🇧","us":"🇺🇸","us_virgin_islands":"🇻🇮","uruguay":"🇺🇾","uzbekistan":"🇺🇿","vanuatu":"🇻🇺","vatican_city":"🇻🇦","venezuela":"🇻🇪","vietnam":"🇻🇳","wallis_futuna":"🇼🇫","western_sahara":"🇪🇭","yemen":"🇾🇪","zambia":"🇿🇲","zimbabwe":"🇿🇼"}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*!
 * inputhistory
 * https://github.com/erming/inputhistory
 * v0.3.1
 */
(function ($) {
	$.inputhistory = {};
	$.inputhistory.defaultOptions = {
		history: [],
		preventSubmit: false
	};

	$.fn.history = // Alias
	$.fn.inputhistory = function (options) {
		options = $.extend($.inputhistory.defaultOptions, options);

		var self = this;
		if (self.length > 1) {
			return self.each(function () {
				$(this).history(options);
			});
		}

		var history = options.history;
		history.push("");

		var i = 0;
		self.on("keydown", function (e) {
			var key = e.which;
			switch (key) {
				case 13:
					// Enter
					if (e.shiftKey || self.data("autocompleting")) {
						return; // multiline input
					}

					if (self.val() != "") {
						i = history.length;
						history[i - 1] = self.val();
						history.push("");
						if (history[i - 1] == history[i - 2]) {
							history.splice(-2, 1);
							i--;
						}
					}
					if (!options.preventSubmit) {
						self.parents("form").eq(0).submit();
					}
					self.val("");
					break;

				case 38: // Up
				case 40:
					// Down
					// NOTICE: This is specific to The Lounge.
					if (e.ctrlKey || e.metaKey || self.data("autocompleting")) {
						break;
					}

					if (this.value.indexOf("\n") >= 0 && key === 38 && this.selectionStart > 0 || key === 40 && this.selectionStart < this.value.length) {
						return; // don't prevent default
					}

					history[i] = self.val();
					if (key == 38 && i != 0) {
						i--;
					} else if (key == 40 && i < history.length - 1) {
						i++;
					}
					self.val(history[i]);
					break;

				default:
					return;
			}

			e.preventDefault();
		});

		return this;
	};
})(_jquery2.default);

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function ($) {
	$.fn.unsticky = function () {
		return this.trigger("unstick.sticky").unbind(".sticky");
	};

	$.fn.sticky = function () {
		var self = this;
		var stuckToBottom = true;
		var lastStick = 0;

		var keepToBottom = function keepToBottom() {
			if (stuckToBottom) {
				self.scrollBottom();
			}
		};

		$(window).on("resize.sticky", keepToBottom);
		self.on("unstick.sticky", function () {
			$(window).off("resize.sticky", keepToBottom);
		}).on("scroll.sticky", function () {
			// When resizing, sometimes the browser sends a bunch of extra scroll events due to content
			// reflow, so if we resized within 250ms we can assume it's one of those. The order of said
			// events is not predictable, and scroll can happen last, so not setting stuckToBottom is
			// not enough, we have to force the scroll still.
			if (stuckToBottom && Date.now() - lastStick < 250) {
				self.scrollBottom();
			} else {
				stuckToBottom = self.isScrollBottom();
			}
		}).on("scrollBottom.sticky", function () {
			stuckToBottom = true;
			lastStick = Date.now();
			this.scrollTop = this.scrollHeight;
		}).on("keepToBottom.sticky", keepToBottom).scrollBottom();

		return self;
	};

	$.fn.scrollBottom = function () {
		this.trigger("scrollBottom.sticky");
		return this;
	};

	$.fn.isScrollBottom = function () {
		var el = this[0];
		return el.scrollHeight - el.scrollTop - el.offsetHeight <= 30;
	};
})(_jquery2.default);

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*!
 * tabcomplete
 * http://github.com/erming/tabcomplete
 * v1.3.1
 */
(function ($) {
	var keys = {
		backspace: 8,
		tab: 9,
		up: 38,
		down: 40
	};

	$.tabcomplete = {};
	$.tabcomplete.defaultOptions = {
		after: "",
		arrowKeys: false,
		caseSensitive: false,
		hint: "placeholder",
		minLength: 1
	};

	$.fn.tab = // Alias
	$.fn.tabcomplete = function (args, options) {
		if (this.length > 1) {
			return this.each(function () {
				$(this).tabcomplete(args, options);
			});
		}

		// Only enable the plugin on <input> and <textarea> elements.
		var tag = this.prop("tagName");
		if (tag != "INPUT" && tag != "TEXTAREA") {
			return;
		}

		// Set default options.
		options = $.extend($.tabcomplete.defaultOptions, options);

		// Remove any leftovers.
		// This allows us to override the plugin if necessary.
		this.unbind(".tabcomplete");
		this.prev(".hint").remove();

		var self = this;
		var backspace = false;
		var i = -1;
		var words = [];
		var last = "";

		var hint = $.noop;

		// Determine what type of hinting to use.
		switch (options.hint) {
			case "placeholder":
				hint = placeholder;
				break;

			case "select":
				hint = select;
				break;
		}

		this.on("input.tabcomplete", function () {
			var input = self.val();
			var word = input.split(/ |\n/).pop();

			// Reset iteration.
			i = -1;
			last = "";
			words = [];

			// Check for matches if the current word is the last word.
			if (self[0].selectionStart == input.length && word.length) {
				if (typeof args === "function") {
					// If the user supplies a function, invoke it
					// and keep the result.
					words = args(word);
				} else {
					// Otherwise, call the .match() function.
					words = match(word, args, options.caseSensitive);
				}

				// Append 'after' to each word.
				if (options.after) {
					words = $.map(words, function (w) {
						return w + options.after;
					});
				}
			}

			// Emit the number of matching words with the 'match' event.
			self.trigger("match", words.length);

			if (options.hint) {
				if (!(options.hint == "select" && backspace) && word.length >= options.minLength) {
					// Show hint.
					hint.call(self, words[0]);
				} else {
					// Clear hinting.
					// This call is needed when using backspace.
					hint.call(self, "");
				}
			}

			if (backspace) {
				backspace = false;
			}
		});

		this.on("keydown.tabcomplete", function (e) {
			var key = e.which;
			if (key == keys.tab && !e.ctrlKey || options.arrowKeys && (key == keys.up || key == keys.down)) {

				// Don't lose focus on tab click.
				e.preventDefault();

				// Iterate the matches with tab and the up and down keys by incrementing
				// or decrementing the 'i' variable.
				if (key != keys.up) {
					i++;
				} else {
					if (i == -1) return;
					if (i == 0) {
						// Jump to the last word.
						i = words.length - 1;
					} else {
						i--;
					}
				}

				// Get next match.
				var word = words[i % words.length];
				if (!word) {
					return;
				}

				var value = self.val();
				last = last || value.split(/ |\n/).pop();

				// Return if the 'minLength' requirement isn't met.
				if (last.length < options.minLength) {
					return;
				}

				// Update element with the completed text.
				var text = value.substr(0, self[0].selectionStart - last.length) + word;
				self.val(text);

				// Put the cursor at the end after completion.
				// This isn't strictly necessary, but solves an issue with
				// Internet Explorer.
				if (options.hint == "select") {
					self[0].selectionStart = text.length;
				}

				// Remember the word until next time.
				last = word;

				// Emit event.
				self.trigger("tabcomplete", last);

				if (options.hint) {
					// Turn off any additional hinting.
					hint.call(self, "");
				}
			} else if (e.which == keys.backspace) {
				// Remember that backspace was pressed. This is used
				// by the 'input' event.
				backspace = true;

				// Reset iteration.
				i = -1;
				last = "";
			}
		});

		if (options.hint) {
			// If enabled, turn on hinting.
			hint.call(this, "");
		}

		return this;
	};

	// Simple matching.
	// Filter the array and return the items that begins with 'word'.
	function match(word, array, caseSensitive) {
		return $.grep(array, function (w) {
			if (caseSensitive) {
				return !w.indexOf(word);
			} else {
				return !w.toLowerCase().indexOf(word.toLowerCase());
			}
		});
	}

	// Show placeholder text.
	// This works by creating a copy of the input and placing it behind
	// the real input.
	function placeholder(word) {
		var input = this;
		var clone = input.prev(".hint");

		input.css({
			backgroundColor: "transparent",
			position: "relative"
		});

		// Lets create a clone of the input if it does
		// not already exist.
		if (!clone.length) {
			input.wrap($("<div>").css({ position: "relative", height: input.css("height") }));
			clone = input.clone().attr("tabindex", -1).removeAttr("id name placeholder").addClass("hint").insertBefore(input);
			clone.css({
				position: "absolute"
			});
		}

		var hint = "";
		if (typeof word !== "undefined") {
			var value = input.val();
			hint = value + word.substr(value.split(/ |\n/).pop().length);
		}

		clone.val(hint);
	}

	// Hint by selecting part of the suggested word.
	function select(word) {
		var input = this;
		var value = input.val();
		if (word) {
			input.val(value + word.substr(value.split(/ |\n/).pop().length));

			// Select hint.
			input[0].selectionStart = value.length;
		}
	}
})(_jquery2.default);

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Simple slideout menu implementation.
 */

module.exports = function slideoutMenu(viewport, menu) {
	var touchStartPos = null;
	var touchCurPos = null;
	var touchStartTime = 0;
	var menuWidth = 0;
	var menuIsOpen = false;
	var menuIsMoving = false;

	function toggleMenu(state) {
		menuIsOpen = state;
		viewport.classList.toggle("menu-open", state);
	}

	function disableSlideout() {
		viewport.removeEventListener("ontouchstart", onTouchStart);
	}

	function onTouchStart(e) {
		if (e.touches.length !== 1) {
			onTouchEnd();
			return;
		}

		var touch = e.touches.item(0);
		viewport.classList.toggle("menu-dragging", true);

		menuWidth = parseFloat(window.getComputedStyle(menu).width);

		if (!menuIsOpen && touch.screenX < 50 || menuIsOpen && touch.screenX > menuWidth) {
			touchStartPos = touch;
			touchCurPos = touch;
			touchStartTime = Date.now();

			viewport.addEventListener("touchmove", onTouchMove);
			viewport.addEventListener("touchend", onTouchEnd, { passive: true });
		}
	}

	function onTouchMove(e) {
		var touch = touchCurPos = e.touches.item(0);
		var setX = touch.screenX - touchStartPos.screenX;

		if (Math.abs(setX > 30)) {
			menuIsMoving = true;
		}

		if (!menuIsMoving && Math.abs(touch.screenY - touchStartPos.screenY) > 30) {
			onTouchEnd();
			return;
		}

		if (menuIsOpen) {
			setX += menuWidth;
		}

		if (setX > menuWidth) {
			setX = menuWidth;
		} else if (setX < 0) {
			setX = 0;
		}

		viewport.style.transform = "translate3d(" + setX + "px, 0, 0)";

		if (menuIsMoving) {
			e.preventDefault();
			e.stopPropagation();
		}
	}

	function onTouchEnd() {
		var diff = touchCurPos.screenX - touchStartPos.screenX;
		var absDiff = Math.abs(diff);

		if (absDiff > menuWidth / 2 || Date.now() - touchStartTime < 180 && absDiff > 50) {
			toggleMenu(diff > 0);
		}

		viewport.removeEventListener("touchmove", onTouchMove);
		viewport.removeEventListener("touchend", onTouchEnd);
		viewport.classList.toggle("menu-dragging", false);
		viewport.style.transform = null;

		touchStartPos = null;
		touchCurPos = null;
		touchStartTime = 0;
		menuIsMoving = false;
	}

	viewport.addEventListener("touchstart", onTouchStart, { passive: true });

	return {
		disable: disableSlideout,
		toggle: toggleMenu,
		isOpen: function isOpen() {
			return menuIsOpen;
		}
	};
};

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "	<div class=\"preview\" data-url=\""
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.link : depth0), depth0))
    + "\"></div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return ((stack1 = container.invokePartial(__webpack_require__(3),depth0,{"name":"../user_name","hash":{"nick":(depth0 != null ? depth0.from : depth0)},"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "<span class=\"text\">"
    + ((stack1 = __default(__webpack_require__(6)).call(alias1,(depth0 != null ? depth0.text : depth0),{"name":"parse","hash":{},"data":data})) != null ? stack1 : "")
    + "</span>\n\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.previews : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true});

/***/ }),
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Generates a string from "color-1" to "color-32" based on an input string

module.exports = function (str) {
	var hash = 0;
	for (var i = 0; i < str.length; i++) {
		hash += str.charCodeAt(i);
	}

	return "color-" + (1 + hash % 32);
};

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Styling control codes

var BOLD = "\x02";
var COLOR = "\x03";
var HEX_COLOR = "\x04";
var RESET = "\x0f";
var REVERSE = "\x16";
var ITALIC = "\x1d";
var UNDERLINE = "\x1f";

// Color code matcher, with format `XX,YY` where both `XX` and `YY` are
// integers, `XX` is the text color and `YY` is an optional background color.
var colorRx = /^(\d{1,2})(?:,(\d{1,2}))?/;

// 6-char Hex color code matcher
var hexColorRx = /^([0-9a-f]{6})(?:,([0-9a-f]{6}))?/i;

// Represents all other control codes that to be ignored/filtered from the text
var controlCodesRx = /[\u0000-\u001F]/g;

// Converts a given text into an array of objects, each of them representing a
// similarly styled section of the text. Each object carries the `text`, style
// information (`bold`, `textColor`, `bgcolor`, `reverse`, `italic`,
// `underline`), and `start`/`end` cursors.
function parseStyle(text) {
	var result = [];
	var start = 0;
	var position = 0;

	// At any given time, these carry style information since last time a styling
	// control code was met.
	var colorCodes = void 0,
	    bold = void 0,
	    textColor = void 0,
	    bgColor = void 0,
	    hexColor = void 0,
	    hexBgColor = void 0,
	    reverse = void 0,
	    italic = void 0,
	    underline = void 0;

	var resetStyle = function resetStyle() {
		bold = false;
		textColor = undefined;
		bgColor = undefined;
		hexColor = undefined;
		hexBgColor = undefined;
		reverse = false;
		italic = false;
		underline = false;
	};
	resetStyle();

	// When called, this "closes" the current fragment by adding an entry to the
	// `result` array using the styling information set last time a control code
	// was met.
	var emitFragment = function emitFragment() {
		// Uses the text fragment starting from the last control code position up to
		// the current position
		var textPart = text.slice(start, position);

		// Filters out all non-style related control codes present in this text
		var processedText = textPart.replace(controlCodesRx, "");

		if (processedText.length) {
			// Current fragment starts where the previous one ends, or at 0 if none
			var fragmentStart = result.length ? result[result.length - 1].end : 0;

			result.push({
				bold: bold,
				textColor: textColor,
				bgColor: bgColor,
				hexColor: hexColor,
				hexBgColor: hexBgColor,
				reverse: reverse,
				italic: italic,
				underline: underline,
				text: processedText,
				start: fragmentStart,
				end: fragmentStart + processedText.length
			});
		}

		// Now that a fragment has been "closed", the next one will start after that
		start = position + 1;
	};

	// This loop goes through each character of the given text one by one by
	// bumping the `position` cursor. Every time a new special "styling" character
	// is met, an object gets created (with `emitFragment()`)information on text
	// encountered since the previous styling character.
	while (position < text.length) {
		switch (text[position]) {
			case RESET:
				emitFragment();
				resetStyle();
				break;

			// Meeting a BOLD character means that the ongoing text is either going to
			// be in bold or that the previous one was in bold and the following one
			// must be reset.
			// This same behavior applies to COLOR, REVERSE, ITALIC, and UNDERLINE.
			case BOLD:
				emitFragment();
				bold = !bold;
				break;

			case COLOR:
				emitFragment();

				// Go one step further to find the corresponding color
				colorCodes = text.slice(position + 1).match(colorRx);

				if (colorCodes) {
					textColor = Number(colorCodes[1]);
					if (colorCodes[2]) {
						bgColor = Number(colorCodes[2]);
					}
					// Color code length is > 1, so bump the current position cursor by as
					// much (and reset the start cursor for the current text block as well)
					position += colorCodes[0].length;
					start = position + 1;
				} else {
					// If no color codes were found, toggles back to no colors (like BOLD).
					textColor = undefined;
					bgColor = undefined;
				}
				break;

			case HEX_COLOR:
				emitFragment();

				colorCodes = text.slice(position + 1).match(hexColorRx);

				if (colorCodes) {
					hexColor = colorCodes[1].toUpperCase();
					if (colorCodes[2]) {
						hexBgColor = colorCodes[2].toUpperCase();
					}
					// Color code length is > 1, so bump the current position cursor by as
					// much (and reset the start cursor for the current text block as well)
					position += colorCodes[0].length;
					start = position + 1;
				} else {
					// If no color codes were found, toggles back to no colors (like BOLD).
					hexColor = undefined;
					hexBgColor = undefined;
				}

				break;

			case REVERSE:
				emitFragment();
				reverse = !reverse;
				break;

			case ITALIC:
				emitFragment();
				italic = !italic;
				break;

			case UNDERLINE:
				emitFragment();
				underline = !underline;
				break;
		}

		// Evaluate the next character at the next iteration
		position += 1;
	}

	// The entire text has been parsed, so we finalize the current text fragment.
	emitFragment();

	return result;
}

var properties = ["bold", "textColor", "bgColor", "hexColor", "hexBgColor", "italic", "underline", "reverse"];

function prepare(text) {
	return parseStyle(text)
	// This optimizes fragments by combining them together when all their values
	// for the properties defined above are equal.
	.reduce(function (prev, curr) {
		if (prev.length) {
			var lastEntry = prev[prev.length - 1];
			if (properties.every(function (key) {
				return curr[key] === lastEntry[key];
			})) {
				lastEntry.text += curr.text;
				lastEntry.end += curr.text.length;
				return prev;
			}
		}
		return prev.concat([curr]);
	}, []);
}

module.exports = prepare;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Escapes the RegExp special characters "^", "$", "", ".", "*", "+", "?", "(",
// ")", "[", "]", "{", "}", and "|" in string.
// See https://lodash.com/docs/#escapeRegExp

var escapeRegExp = __webpack_require__(201);

// Given an array of channel prefixes (such as "#" and "&") and an array of user
// modes (such as "@" and "+"), this function extracts channels and nicks from a
// text.
// It returns an array of objects for each channel found with their start index,
// end index and channel name.
function findChannels(text, channelPrefixes, userModes) {
	// `userModePattern` is necessary to ignore user modes in /whois responses.
	// For example, a voiced user in #thelounge will have a /whois response of:
	// > foo is on the following channels: +#thelounge
	// We need to explicitly ignore user modes to parse such channels correctly.
	var userModePattern = userModes.map(escapeRegExp).join("");
	var channelPrefixPattern = channelPrefixes.map(escapeRegExp).join("");
	var channelPattern = "(?:^|\\s)[" + userModePattern + "]*([" + channelPrefixPattern + "][^ \x07]+)";
	var channelRegExp = new RegExp(channelPattern, "g");

	var result = [];
	var match = void 0;

	do {
		// With global ("g") regexes, calling `exec` multiple times will find
		// successive matches in the same string.
		match = channelRegExp.exec(text);

		if (match) {
			result.push({
				start: match.index + match[0].length - match[1].length,
				end: match.index + match[0].length,
				channel: match[1]
			});
		}
	} while (match);

	return result;
}

module.exports = findChannels;

/***/ }),
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var URI = __webpack_require__(146);

// Known schemes to detect in a text. If a text contains `foo...bar://foo.com`,
// the parsed scheme should be `foo...bar` but if it contains
// `foo...http://foo.com`, we assume the scheme to extract will be `http`.
var commonSchemes = ["http", "https", "ftp", "sftp", "smb", "file", "irc", "ircs", "svn", "git", "steam", "mumble", "ts3server", "svn+ssh", "ssh"];

function findLinks(text) {
	var result = [];

	// URI.withinString() identifies URIs within text, e.g. to translate them to
	// <a>-Tags.
	// See https://medialize.github.io/URI.js/docs.html#static-withinString
	// In our case, we store each URI encountered in a result array.
	URI.withinString(text, function (url, start, end) {
		// Extract the scheme of the URL detected, if there is one
		var parsedScheme = URI(url).scheme().toLowerCase();

		// Check if the scheme of the detected URL matches a common one above.
		// In a URL like `foo..http://example.com`, the scheme would be `foo..http`,
		// so we need to clean up the end of the scheme and filter out the rest.
		var matchedScheme = commonSchemes.find(function (scheme) {
			return parsedScheme.endsWith(scheme);
		});

		// A known scheme was found, extract the unknown part from the URL
		if (matchedScheme) {
			var prefix = parsedScheme.length - matchedScheme.length;
			start += prefix;
			url = url.slice(prefix);
		}

		// The URL matched but does not start with a scheme (`www.foo.com`), add it
		if (!parsedScheme.length) {
			url = "http://" + url;
		}

		result.push({
			start: start,
			end: end,
			link: url
		});
	});

	return result;
}

module.exports = findLinks;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anyIntersection = __webpack_require__(215);
var fill = __webpack_require__(216);

var Object_assign = Object.assign;

if (typeof Object_assign !== "function") {
	Object_assign = function Object_assign(target) {
		Array.prototype.slice.call(arguments, 1).forEach(function (obj) {
			Object.keys(obj).forEach(function (key) {
				target[key] = obj[key];
			});
		});
		return target;
	};
}

// Merge text part information within a styling fragment
function assign(textPart, fragment) {
	var fragStart = fragment.start;
	var start = Math.max(fragment.start, textPart.start);
	var end = Math.min(fragment.end, textPart.end);

	return Object_assign({}, fragment, {
		start: start,
		end: end,
		text: fragment.text.slice(start - fragStart, end - fragStart)
	});
}

// Merge the style fragments withing the text parts, taking into account
// boundaries and text sections that have not matched to links or channels.
// For example, given a string "foobar" where "foo" and "bar" have been
// identified as parts (channels, links, etc.) and "fo", "ob" and "ar" have 3
// different styles, the first resulting part will contain fragments "fo" and
// "o", and the second resulting part will contain "b" and "ar". "o" and "b"
// fragments will contain duplicate styling attributes.
function merge(textParts, styleFragments) {
	// Re-build the overall text (without control codes) from the style fragments
	var cleanText = styleFragments.reduce(function (acc, frag) {
		return acc + frag.text;
	}, "");

	// Every section of the original text that has not been captured in a "part"
	// is filled with "text" parts, dummy objects with start/end but no extra
	// metadata.
	var allParts = textParts.concat(fill(textParts, cleanText)).sort(function (a, b) {
		return a.start - b.start;
	});

	// Distribute the style fragments within the text parts
	return allParts.map(function (textPart) {
		textPart.fragments = styleFragments.filter(function (fragment) {
			return anyIntersection(textPart, fragment);
		}).map(function (fragment) {
			return assign(textPart, fragment);
		});

		return textPart;
	});
}

module.exports = merge;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Return true if any section of "a" or "b" parts (defined by their start/end
// markers) intersect each other, false otherwise.

function anyIntersection(a, b) {
	return a.start <= b.start && b.start < a.end || a.start < b.end && b.end <= a.end || b.start <= a.start && a.start < b.end || b.start < a.end && a.end <= b.end;
}

module.exports = anyIntersection;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Create plain text entries corresponding to areas of the text that match no
// existing entries. Returns an empty array if all parts of the text have been
// parsed into recognizable entries already.

function fill(existingEntries, text) {
	var position = 0;

	// Fill inner parts of the text. For example, if text is `foobarbaz` and both
	// `foo` and `baz` have matched into an entry, this will return a dummy entry
	// corresponding to `bar`.
	var result = existingEntries.reduce(function (acc, textSegment) {
		if (textSegment.start > position) {
			acc.push({
				start: position,
				end: textSegment.start
			});
		}
		position = textSegment.end;
		return acc;
	}, []);

	// Complete the unmatched end of the text with a dummy entry
	if (position < text.length) {
		result.push({
			start: position,
			end: text.length
		});
	}

	return result;
}

module.exports = fill;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "			<tr>\n				<td class=\"hostmask\">"
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.hostmask : depth0), depth0))
    + "</td>\n				<td class=\"banned_by\">"
    + ((stack1 = __default(__webpack_require__(6)).call(alias1,(depth0 != null ? depth0.banned_by : depth0),{"name":"parse","hash":{},"data":data})) != null ? stack1 : "")
    + "</td>\n				<td class=\"banned_at\">"
    + ((stack1 = __default(__webpack_require__(11)).call(alias1,(depth0 != null ? depth0.banned_at : depth0),{"name":"localetime","hash":{},"data":data})) != null ? stack1 : "")
    + "</td>\n			</tr>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<table class=\"ban-list\">\n	<thead>\n		<tr>\n			<th class=\"hostmask\">Banned</th>\n			<th class=\"banned_by\">Banned By</th>\n			<th class=\"banned_at\">Banned At</th>\n		</tr>\n	</thead>\n	<tbody>\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.bans : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "	</tbody>\n</table>\n";
},"useData":true});

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "			<tr>\n				<td class=\"channel\">"
    + ((stack1 = __default(__webpack_require__(6)).call(alias1,(depth0 != null ? depth0.channel : depth0),{"name":"parse","hash":{},"data":data})) != null ? stack1 : "")
    + "</td>\n				<td class=\"users\">"
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.num_users : depth0), depth0))
    + "</td>\n				<td class=\"topic\">"
    + ((stack1 = __default(__webpack_require__(6)).call(alias1,(depth0 != null ? depth0.topic : depth0),{"name":"parse","hash":{},"data":data})) != null ? stack1 : "")
    + "</td>\n			</tr>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<table class=\"channel-list\">\n	<thead>\n		<tr>\n			<th class=\"channel\">Channel</th>\n			<th class=\"users\">Users</th>\n			<th class=\"topic\">Topic</th>\n		</tr>\n	</thead>\n	<tbody>\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.channels : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "	</tbody>\n</table>\n";
},"useData":true});

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(__webpack_require__(3),depth0,{"name":"../user_name","hash":{"nick":(depth0 != null ? depth0.from : depth0)},"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "<b>"
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.ctcpType : depth0), depth0))
    + "</b> <span class=\"ctcp-message\">"
    + ((stack1 = __default(__webpack_require__(6)).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.ctcpMessage : depth0),{"name":"parse","hash":{},"data":data})) != null ? stack1 : "")
    + "</span>\n";
},"usePartial":true,"useData":true});

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "	you\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(__webpack_require__(3),depth0,{"name":"../user_name","hash":{"nick":(depth0 != null ? depth0.invited : depth0)},"data":data,"indent":"\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return ((stack1 = container.invokePartial(__webpack_require__(3),depth0,{"name":"../user_name","hash":{"nick":(depth0 != null ? depth0.from : depth0)},"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "invited\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.invitedYou : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "to\n"
    + ((stack1 = __default(__webpack_require__(6)).call(alias1,(depth0 != null ? depth0.channel : depth0),{"name":"parse","hash":{},"data":data})) != null ? stack1 : "")
    + "\n";
},"usePartial":true,"useData":true});

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(__webpack_require__(3),depth0,{"name":"../user_name","hash":{"nick":(depth0 != null ? depth0.from : depth0)},"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "<i class=\"hostmask\">("
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.hostmask : depth0), depth0))
    + ")</i>\nhas joined the channel\n";
},"usePartial":true,"useData":true});

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "	<i class=\"part-reason\">("
    + ((stack1 = __default(__webpack_require__(6)).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.text : depth0),{"name":"parse","hash":{},"data":data})) != null ? stack1 : "")
    + ")</i>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(__webpack_require__(3),depth0,{"name":"../user_name","hash":{"nick":(depth0 != null ? depth0.from : depth0)},"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "has kicked\n"
    + ((stack1 = container.invokePartial(__webpack_require__(3),depth0,{"name":"../user_name","hash":{"mode":"","nick":(depth0 != null ? depth0.target : depth0)},"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.text : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true});

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(__webpack_require__(3),depth0,{"name":"../user_name","hash":{"nick":(depth0 != null ? depth0.from : depth0)},"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "sets mode\n"
    + ((stack1 = __default(__webpack_require__(6)).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.text : depth0),{"name":"parse","hash":{},"data":data})) != null ? stack1 : "")
    + "\n";
},"usePartial":true,"useData":true});

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(__webpack_require__(3),depth0,{"name":"../user_name","hash":{"nick":(depth0 != null ? depth0.from : depth0)},"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "is now known as\n"
    + ((stack1 = container.invokePartial(__webpack_require__(3),depth0,{"name":"../user_name","hash":{"nick":(depth0 != null ? depth0.new_nick : depth0)},"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"usePartial":true,"useData":true});

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "	<i class=\"part-reason\">("
    + ((stack1 = __default(__webpack_require__(6)).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.text : depth0),{"name":"parse","hash":{},"data":data})) != null ? stack1 : "")
    + ")</i>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(__webpack_require__(3),depth0,{"name":"../user_name","hash":{"nick":(depth0 != null ? depth0.from : depth0)},"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "<i class=\"hostmask\">("
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.hostmask : depth0), depth0))
    + ")</i>\nhas left the channel\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.text : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true});

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "	<i class=\"quit-reason\">("
    + ((stack1 = __default(__webpack_require__(6)).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.text : depth0),{"name":"parse","hash":{},"data":data})) != null ? stack1 : "")
    + ")</i>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(__webpack_require__(3),depth0,{"name":"../user_name","hash":{"nick":(depth0 != null ? depth0.from : depth0)},"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "<i class=\"hostmask\">("
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.hostmask : depth0), depth0))
    + ")</i>\nhas quit\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.text : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true});

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(__webpack_require__(3),depth0,{"name":"../user_name","hash":{"nick":(depth0 != null ? depth0.from : depth0)},"data":data,"indent":"\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "	has changed the topic to:\n";
},"3":function(container,depth0,helpers,partials,data) {
    return "	The topic is:\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.from : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "\n<span class=\"new-topic\">"
    + ((stack1 = __default(__webpack_require__(6)).call(alias1,(depth0 != null ? depth0.text : depth0),{"name":"parse","hash":{},"data":data})) != null ? stack1 : "")
    + "</span>\n";
},"usePartial":true,"useData":true});

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "Topic set by\n"
    + ((stack1 = container.invokePartial(__webpack_require__(3),depth0,{"name":"../user_name","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "on "
    + container.escapeExpression(__default(__webpack_require__(11)).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.when : depth0),{"name":"localetime","hash":{},"data":data}))
    + "\n";
},"usePartial":true,"useData":true});

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div>\n"
    + ((stack1 = container.invokePartial(__webpack_require__(3),depth0,{"name":"../user_name","hash":{"nick":((stack1 = (depth0 != null ? depth0.whois : depth0)) != null ? stack1.nick : stack1)},"data":data,"indent":"\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "	is logged in as <b>"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.whois : depth0)) != null ? stack1.account : stack1), depth0))
    + "</b>\n</div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div>\n"
    + ((stack1 = container.invokePartial(__webpack_require__(3),depth0,{"name":"../user_name","hash":{"nick":((stack1 = (depth0 != null ? depth0.whois : depth0)) != null ? stack1.nick : stack1)},"data":data,"indent":"\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "	is on the following channels: "
    + ((stack1 = __default(__webpack_require__(6)).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? depth0.whois : depth0)) != null ? stack1.channels : stack1),{"name":"parse","hash":{},"data":data})) != null ? stack1 : "")
    + "\n</div>\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "<div>\n"
    + ((stack1 = container.invokePartial(__webpack_require__(3),depth0,{"name":"../user_name","hash":{"nick":((stack1 = (depth0 != null ? depth0.whois : depth0)) != null ? stack1.nick : stack1)},"data":data,"indent":"\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "	is connected to "
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.whois : depth0)) != null ? stack1.server : stack1), depth0))
    + " <i>("
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.whois : depth0)) != null ? stack1.server_info : stack1), depth0))
    + ")</i>\n</div>\n";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div>\n"
    + ((stack1 = container.invokePartial(__webpack_require__(3),depth0,{"name":"../user_name","hash":{"nick":((stack1 = (depth0 != null ? depth0.whois : depth0)) != null ? stack1.nick : stack1)},"data":data,"indent":"\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "	is using a secure connection\n</div>\n";
},"9":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div>\n"
    + ((stack1 = container.invokePartial(__webpack_require__(3),depth0,{"name":"../user_name","hash":{"nick":((stack1 = (depth0 != null ? depth0.whois : depth0)) != null ? stack1.nick : stack1)},"data":data,"indent":"\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "	is away <i>("
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.whois : depth0)) != null ? stack1.away : stack1), depth0))
    + ")</i>\n</div>\n";
},"11":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div>\n"
    + ((stack1 = container.invokePartial(__webpack_require__(3),depth0,{"name":"../user_name","hash":{"nick":((stack1 = (depth0 != null ? depth0.whois : depth0)) != null ? stack1.nick : stack1)},"data":data,"indent":"\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "	has been idle since "
    + container.escapeExpression(__default(__webpack_require__(11)).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? depth0.whois : depth0)) != null ? stack1.idleTime : stack1),{"name":"localetime","hash":{},"data":data}))
    + ".\n</div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div>\n"
    + ((stack1 = container.invokePartial(__webpack_require__(3),depth0,{"name":"../user_name","hash":{"nick":((stack1 = (depth0 != null ? depth0.whois : depth0)) != null ? stack1.nick : stack1)},"data":data,"indent":"\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "	<i class=\"hostmask\">("
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.whois : depth0)) != null ? stack1.user : stack1), depth0))
    + "@"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.whois : depth0)) != null ? stack1.host : stack1), depth0))
    + ")</i>:\n	<b>"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.whois : depth0)) != null ? stack1.real_name : stack1), depth0))
    + "</b>\n</div>\n"
    + ((stack1 = helpers["if"].call(alias3,((stack1 = (depth0 != null ? depth0.whois : depth0)) != null ? stack1.account : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(alias3,((stack1 = (depth0 != null ? depth0.whois : depth0)) != null ? stack1.channels : stack1),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(alias3,((stack1 = (depth0 != null ? depth0.whois : depth0)) != null ? stack1.server : stack1),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(alias3,((stack1 = (depth0 != null ? depth0.whois : depth0)) != null ? stack1.secure : stack1),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(alias3,((stack1 = (depth0 != null ? depth0.whois : depth0)) != null ? stack1.away : stack1),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(alias3,((stack1 = (depth0 != null ? depth0.whois : depth0)) != null ? stack1.idle : stack1),{"name":"if","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true});

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div id=\"chan-"
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\" data-title=\""
    + alias2(alias1((depth0 != null ? depth0.name : depth0), depth0))
    + "\" data-id=\""
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\" data-type=\""
    + alias2(alias1((depth0 != null ? depth0.type : depth0), depth0))
    + "\" data-target=\"#chan-"
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\" class=\"chan "
    + alias2(alias1((depth0 != null ? depth0.type : depth0), depth0))
    + "\">\n	<div class=\"header\">\n		<button class=\"lt\" aria-label=\"Toggle channel list\"></button>\n"
    + ((stack1 = __default(__webpack_require__(12)).call(alias3,(depth0 != null ? depth0.type : depth0),"channel",{"name":"equal","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "		<button class=\"menu\" aria-label=\"Open the context menu\"></button>\n		<span class=\"title\">"
    + alias2(alias1((depth0 != null ? depth0.name : depth0), depth0))
    + "</span>\n		<span title=\""
    + alias2(alias1((depth0 != null ? depth0.topic : depth0), depth0))
    + "\" class=\"topic\">"
    + ((stack1 = __default(__webpack_require__(6)).call(alias3,(depth0 != null ? depth0.topic : depth0),{"name":"parse","hash":{},"data":data})) != null ? stack1 : "")
    + "</span>\n	</div>\n	<div class=\"chat\">\n		<div class=\"show-more "
    + ((stack1 = __default(__webpack_require__(12)).call(alias3,((stack1 = (depth0 != null ? depth0.messages : depth0)) != null ? stack1.length : stack1),100,{"name":"equal","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\">\n			<button class=\"show-more-button\" data-id=\""
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\">\n				Show older messages\n			</button>\n		</div>\n		<div class=\"messages\"></div>\n	</div>\n"
    + ((stack1 = __default(__webpack_require__(12)).call(alias3,(depth0 != null ? depth0.type : depth0),"channel",{"name":"equal","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "			<span class=\"rt-tooltip tooltipped tooltipped-w\" aria-label=\"Toggle user list\">\n				<button class=\"rt\" aria-label=\"Toggle user list\"></button>\n			</span>\n";
},"4":function(container,depth0,helpers,partials,data) {
    return "show";
},"6":function(container,depth0,helpers,partials,data) {
    return "	<aside class=\"sidebar\">\n		<div class=\"users\">\n			<div class=\"count\">\n				<input type=\"search\" class=\"search\" aria-label=\"Search among the user list\" tabindex=\"-1\">\n			</div>\n			<div class=\"names names-filtered\"></div>\n			<div class=\"names names-original\"></div>\n		</div>\n	</aside>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.channels : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"useData":true});

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<li class=\"context-menu-divider\" />\n";
},"useData":true});

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var helper;

  return " data-data=\""
    + container.escapeExpression(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"data","hash":{},"data":data}) : helper)))
    + "\"";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<li class=\"context-menu-item context-menu-"
    + alias4(((helper = (helper = helpers["class"] || (depth0 != null ? depth0["class"] : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"class","hash":{},"data":data}) : helper)))
    + "\" data-action=\""
    + alias4(((helper = (helper = helpers["class"] || (depth0 != null ? depth0["class"] : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"class","hash":{},"data":data}) : helper)))
    + "\""
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.data : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ">\n	"
    + alias4(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper)))
    + "\n</li>\n";
},"useData":true});

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, alias2=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div class=\"date-marker-container tooltipped tooltipped-s\" data-timestamp=\""
    + alias1(container.lambda((depth0 != null ? depth0.msgDate : depth0), depth0))
    + "\" aria-label=\""
    + alias1(__default(__webpack_require__(234)).call(alias2,(depth0 != null ? depth0.msgDate : depth0),{"name":"localedate","hash":{},"data":data}))
    + "\">\n	<div class=\"date-marker\">\n		<span class=\"date-marker-text\" data-label=\""
    + alias1(__default(__webpack_require__(235)).call(alias2,(depth0 != null ? depth0.msgDate : depth0),{"name":"friendlydate","hash":{},"data":data}))
    + "\"></span>\n	</div>\n</div>\n";
},"useData":true});

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var moment = __webpack_require__(0);

module.exports = function (time) {
	return moment(time).format("D MMMM YYYY");
};

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var moment = __webpack_require__(0);

module.exports = function (time) {
	// See http://momentjs.com/docs/#/displaying/calendar-time/
	return moment(time).calendar(null, {
		sameDay: "[Today]",
		lastDay: "[Yesterday]",
		lastWeek: "D MMMM YYYY",
		sameElse: "D MMMM YYYY"
	});
};

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return " self";
},"3":function(container,depth0,helpers,partials,data) {
    return " highlight";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(__webpack_require__(3),depth0,{"name":"user_name","hash":{"nick":(depth0 != null ? depth0.from : depth0)},"data":data,"indent":"\t\t\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"7":function(container,depth0,helpers,partials,data) {
    return "			<div class=\"preview\" data-url=\""
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.link : depth0), depth0))
    + "\"></div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div class=\"msg "
    + alias2(alias1((depth0 != null ? depth0.type : depth0), depth0))
    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.self : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.highlight : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\"msg-"
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\" data-time=\""
    + alias2(alias1((depth0 != null ? depth0.time : depth0), depth0))
    + "\" data-from=\""
    + alias2(alias1((depth0 != null ? depth0.from : depth0), depth0))
    + "\">\n	<span class=\"time tooltipped tooltipped-e\" aria-label=\""
    + alias2(__default(__webpack_require__(11)).call(alias3,(depth0 != null ? depth0.time : depth0),{"name":"localetime","hash":{},"data":data}))
    + "\">\n		"
    + alias2(__default(__webpack_require__(19)).call(alias3,(depth0 != null ? depth0.time : depth0),{"name":"tz","hash":{},"data":data}))
    + "\n	</span>\n	<span class=\"from\">\n"
    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.from : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "	</span>\n	<span class=\"content\">\n		<span class=\"text\">"
    + ((stack1 = __default(__webpack_require__(6)).call(alias3,(depth0 != null ? depth0.text : depth0),{"name":"parse","hash":{},"data":data})) != null ? stack1 : "")
    + "</span>\n\n"
    + ((stack1 = helpers.each.call(alias3,(depth0 != null ? depth0.previews : depth0),{"name":"each","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "	</span>\n</div>\n";
},"usePartial":true,"useData":true});

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return " self";
},"3":function(container,depth0,helpers,partials,data) {
    return " highlight";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div class=\"msg "
    + alias2(alias1((depth0 != null ? depth0.type : depth0), depth0))
    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.self : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.highlight : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\"msg-"
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\" data-time=\""
    + alias2(alias1((depth0 != null ? depth0.time : depth0), depth0))
    + "\">\n	<span class=\"time tooltipped tooltipped-e\" aria-label=\""
    + alias2(__default(__webpack_require__(11)).call(alias3,(depth0 != null ? depth0.time : depth0),{"name":"localetime","hash":{},"data":data}))
    + "\">\n		"
    + alias2(__default(__webpack_require__(19)).call(alias3,(depth0 != null ? depth0.time : depth0),{"name":"tz","hash":{},"data":data}))
    + "\n	</span>\n	<span class=\"from\"></span>\n	<span class=\"content\"></span>\n</div>\n";
},"useData":true});

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div class=\"toggle-content toggle-type-"
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.type : depth0), depth0))
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.shown : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\">\n"
    + ((stack1 = __default(__webpack_require__(12)).call(alias1,(depth0 != null ? depth0.type : depth0),"image",{"name":"equal","hash":{},"fn":container.program(4, data, 0),"inverse":container.program(6, data, 0),"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    return " show";
},"4":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "		<a class=\"toggle-thumbnail\" href=\""
    + alias2(alias1((depth0 != null ? depth0.link : depth0), depth0))
    + "\" target=\"_blank\" rel=\"noopener\">\n			<img src=\""
    + alias2(alias1((depth0 != null ? depth0.thumb : depth0), depth0))
    + "\">\n		</a>\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.thumb : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "		<a class=\"toggle-text\" href=\""
    + alias2(alias1((depth0 != null ? depth0.link : depth0), depth0))
    + "\" target=\"_blank\" rel=\"noopener\">\n			<div class=\"head\" title=\""
    + alias2(alias1((depth0 != null ? depth0.head : depth0), depth0))
    + "\">"
    + alias2(alias1((depth0 != null ? depth0.head : depth0), depth0))
    + "</div>\n			<div class=\"body\" title=\""
    + alias2(alias1((depth0 != null ? depth0.body : depth0), depth0))
    + "\">"
    + alias2(alias1((depth0 != null ? depth0.body : depth0), depth0))
    + "</div>\n		</a>\n";
},"7":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "			<a class=\"toggle-thumbnail\" href=\""
    + alias2(alias1((depth0 != null ? depth0.link : depth0), depth0))
    + "\" target=\"_blank\" rel=\"noopener\">\n				<img src=\""
    + alias2(alias1((depth0 != null ? depth0.thumb : depth0), depth0))
    + "\" class=\"thumb\">\n			</a>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.blockHelperMissing.call(depth0,container.lambda((depth0 != null ? depth0.preview : depth0), depth0),{"name":"preview","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"useData":true});

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<button class=\"toggle-button "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.shown : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\"\n  data-url=\""
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.link : depth0), depth0))
    + "\"\n"
    + ((stack1 = __default(__webpack_require__(12)).call(alias1,(depth0 != null ? depth0.type : depth0),"image",{"name":"equal","hash":{},"fn":container.program(4, data, 0),"inverse":container.program(6, data, 0),"data":data})) != null ? stack1 : "")
    + "></button>\n";
},"2":function(container,depth0,helpers,partials,data) {
    return " opened";
},"4":function(container,depth0,helpers,partials,data) {
    return "    aria-label=\"Toggle image preview\"\n";
},"6":function(container,depth0,helpers,partials,data) {
    return "    aria-label=\"Toggle website preview\"\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.blockHelperMissing.call(depth0,container.lambda((depth0 != null ? depth0.preview : depth0), depth0),{"name":"preview","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"useData":true});

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return " self";
},"3":function(container,depth0,helpers,partials,data) {
    return " highlight";
},"5":function(container,depth0,helpers,partials,data) {
    return "			<span>"
    + container.escapeExpression(container.lambda(depth0, depth0))
    + "</span>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression, alias3=container.lambda;

  return "<div class=\"msg msg-"
    + alias2(__default(__webpack_require__(18)).call(alias1,(depth0 != null ? depth0.command : depth0),{"name":"slugify","hash":{},"data":data}))
    + " "
    + alias2(alias3((depth0 != null ? depth0.type : depth0), depth0))
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.self : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.highlight : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" data-time=\""
    + alias2(alias3((depth0 != null ? depth0.time : depth0), depth0))
    + "\">\n	<span class=\"time tooltipped tooltipped-e\" aria-label=\""
    + alias2(__default(__webpack_require__(11)).call(alias1,(depth0 != null ? depth0.time : depth0),{"name":"localetime","hash":{},"data":data}))
    + "\">\n		"
    + alias2(__default(__webpack_require__(19)).call(alias1,(depth0 != null ? depth0.time : depth0),{"name":"tz","hash":{},"data":data}))
    + "\n	</span>\n	<span class=\"from\">["
    + alias2(alias3((depth0 != null ? depth0.command : depth0), depth0))
    + "]</span>\n	<span class=\"content\">\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.params : depth0),{"name":"each","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "	</span>\n</div>\n";
},"useData":true});

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {});

  return "<section id=\"network-"
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\" class=\"network name-"
    + alias2(__default(__webpack_require__(18)).call(alias3,(depth0 != null ? depth0.name : depth0),{"name":"slugify","hash":{},"data":data}))
    + " "
    + ((stack1 = helpers["if"].call(alias3,((stack1 = (depth0 != null ? depth0.serverOptions : depth0)) != null ? stack1.NETWORK : stack1),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" data-id=\""
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\" data-nick=\""
    + alias2(alias1((depth0 != null ? depth0.nick : depth0), depth0))
    + "\" data-options=\""
    + alias2(__default(__webpack_require__(242)).call(alias3,(depth0 != null ? depth0.serverOptions : depth0),{"name":"tojson","hash":{},"data":data}))
    + "\">\n"
    + ((stack1 = container.invokePartial(__webpack_require__(152),depth0,{"name":"chan","data":data,"indent":"\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</section>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "network-"
    + container.escapeExpression(__default(__webpack_require__(18)).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? depth0.serverOptions : depth0)) != null ? stack1.NETWORK : stack1),{"name":"slugify","hash":{},"data":data}));
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.networks : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true});

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (context) {
	return window.JSON.stringify(context);
};

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "  <button class=\"previous-image-btn\" aria-label=\"Previous image\"></button>\n";
},"3":function(container,depth0,helpers,partials,data) {
    return "  <button class=\"next-image-btn\" aria-label=\"Next image\"></button>\n";
},"5":function(container,depth0,helpers,partials,data) {
    return "    Open image\n";
},"7":function(container,depth0,helpers,partials,data) {
    return "    Visit page\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.lambda, alias3=container.escapeExpression;

  return "<button class=\"close-btn\" aria-label=\"Close\"></button>\n\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.hasPreviousImage : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.hasNextImage : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n<a class=\"image-link\" href=\""
    + alias3(alias2((depth0 != null ? depth0.link : depth0), depth0))
    + "\" target=\"_blank\">\n  <img src=\""
    + alias3(alias2((depth0 != null ? depth0.image : depth0), depth0))
    + "\" alt=\"Preview of "
    + alias3(alias2((depth0 != null ? depth0.link : depth0), depth0))
    + "\">\n</a>\n\n<a class=\"btn open-btn\" href=\""
    + alias3(alias2((depth0 != null ? depth0.link : depth0), depth0))
    + "\" target=\"_blank\">\n"
    + ((stack1 = __default(__webpack_require__(12)).call(alias1,(depth0 != null ? depth0.type : depth0),"image",{"name":"equal","hash":{},"fn":container.program(5, data, 0),"inverse":container.program(7, data, 0),"data":data})) != null ? stack1 : "")
    + "</a>\n";
},"useData":true});

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"unread-marker\">\n	<span class=\"unread-marker-text\"></span>\n</div>\n";
},"useData":true});

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = __default(__webpack_require__(154)).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.mode : depth0),{"name":"diff","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = container.invokePartial(__webpack_require__(3),depth0,{"name":"user_name","data":data,"indent":"\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return ((stack1 = helpers.unless.call(alias1,(data && data.first),{"name":"unless","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "	<div class=\"user-mode "
    + container.escapeExpression(__default(__webpack_require__(246)).call(alias1,(depth0 != null ? depth0.mode : depth0),{"name":"modes","hash":{},"data":data}))
    + "\">\n";
},"5":function(container,depth0,helpers,partials,data) {
    return "		</div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return ((stack1 = __default(__webpack_require__(154)).call(alias1,"reset",{"name":"diff","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.users : depth0),{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"usePartial":true,"useData":true});

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (mode) {
	var modes = {
		"~": "owner",
		"&": "admin",
		"!": "admin",
		"@": "op",
		"%": "half-op",
		"+": "voice",
		"": "normal"
	};
	return modes[mode];
};

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression;

  return "	<span role=\"button\" class=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.original : depth0)) != null ? stack1.className : stack1), depth0))
    + "\" data-name=\""
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.original : depth0)) != null ? stack1.dataset : stack1)) != null ? stack1.name : stack1), depth0))
    + "\">"
    + ((stack1 = ((helper = (helper = helpers.string || (depth0 != null ? depth0.string : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"string","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"user-mode user-mode-search\">\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.matches : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"useData":true});

/***/ }),
/* 248 */,
/* 249 */,
/* 250 */
/***/ (function(module, exports) {

module.exports = JSON;

/***/ }),
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(273);
__webpack_require__(274);
__webpack_require__(275);
__webpack_require__(277);
__webpack_require__(278);
__webpack_require__(279);
__webpack_require__(280);
__webpack_require__(281);
__webpack_require__(282);
__webpack_require__(283);
__webpack_require__(284);
__webpack_require__(285);
__webpack_require__(286);
__webpack_require__(287);
__webpack_require__(288);
__webpack_require__(289);

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(1);
var socket = __webpack_require__(4);
var storage = __webpack_require__(17);

socket.on("auth", function (data) {
	var login = $("#sign-in");
	var token = void 0;

	login.find(".btn").prop("disabled", false);

	if (!data.success) {
		storage.remove("token");

		var error = login.find(".error");
		error.show().closest("form").one("submit", function () {
			error.hide();
		});
	} else {
		token = storage.get("token");
		if (token) {
			$("#loading-page-message").text("Authorizing…");
			socket.emit("auth", { token: token });
		}
	}

	var input = login.find("input[name='user']");
	if (input.val() === "") {
		input.val(storage.get("user") || "");
	}
	if (token) {
		return;
	}
	$("#sidebar, #footer").find(".sign-in").trigger("click", {
		pushState: false
	}).end().find(".networks").html("").next().show();
});

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(1);
var socket = __webpack_require__(4);
var storage = __webpack_require__(17);

socket.on("change-password", function (data) {
	var passwordForm = $("#change-password");
	if (data.error || data.success) {
		var message = data.success ? data.success : data.error;
		var feedback = passwordForm.find(".feedback");

		if (data.success) {
			feedback.addClass("success").removeClass("error");
		} else {
			feedback.addClass("error").removeClass("success");
		}

		feedback.text(message).show();
		feedback.closest("form").one("submit", function () {
			feedback.hide();
		});
	}

	if (data.token && storage.get("token") !== null) {
		storage.set("token", data.token);
	}

	passwordForm.find("input").val("").end().find(".btn").prop("disabled", false);
});

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(1);
var socket = __webpack_require__(4);
var render = __webpack_require__(15);
var sidebar = $("#sidebar");
var storage = __webpack_require__(17);

socket.on("init", function (data) {
	$("#loading-page-message").text("Rendering…");

	if (data.networks.length === 0) {
		$("#footer").find(".connect").trigger("click", {
			pushState: false
		});
	} else {
		render.renderNetworks(data);
	}

	if (data.token && $("#sign-in-remember").is(":checked")) {
		storage.set("token", data.token);
	} else {
		storage.remove("token");
	}

	$("body").removeClass("signed-out");
	$("#loading").remove();
	$("#sign-in").remove();

	var id = data.active;
	var target = sidebar.find("[data-id='" + id + "']").trigger("click", {
		replaceHistory: true
	});
	if (target.length === 0) {
		var first = sidebar.find(".chan").eq(0).trigger("click");
		if (first.length === 0) {
			$("#footer").find(".connect").trigger("click", {
				pushState: false
			});
		}
	}
});

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(1);
var sidebar = $("#sidebar, #footer");
var socket = __webpack_require__(4);
var options = __webpack_require__(13);

module.exports = function () {
	sidebar.find(".networks").sortable({
		axis: "y",
		containment: "parent",
		cursor: "move",
		distance: 12,
		items: ".network",
		handle: ".lobby",
		placeholder: "network-placeholder",
		forcePlaceholderSize: true,
		tolerance: "pointer", // Use the pointer to figure out where the network is in the list

		update: function update() {
			var order = [];
			sidebar.find(".network").each(function () {
				var id = $(this).data("id");
				order.push(id);
			});
			socket.emit("sort", {
				type: "networks",
				order: order
			});

			options.ignoreSortSync = true;
		}
	});
	sidebar.find(".network").sortable({
		axis: "y",
		containment: "parent",
		cursor: "move",
		distance: 12,
		items: ".chan:not(.lobby)",
		placeholder: "chan-placeholder",
		forcePlaceholderSize: true,
		tolerance: "pointer", // Use the pointer to figure out where the channel is in the list

		update: function update(e, ui) {
			var order = [];
			var network = ui.item.parent();
			network.find(".chan").each(function () {
				var id = $(this).data("id");
				order.push(id);
			});
			socket.emit("sort", {
				type: "channels",
				target: network.data("id"),
				order: order
			});

			options.ignoreSortSync = true;
		}
	});
};

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(1);
var socket = __webpack_require__(4);
var render = __webpack_require__(15);
var chat = $("#chat");
var templates = __webpack_require__(10);
var sidebar = $("#sidebar");

socket.on("join", function (data) {
	var id = data.network;
	var network = sidebar.find("#network-" + id);
	network.append(templates.chan({
		channels: [data.chan]
	}));
	chat.append(templates.chat({
		channels: [data.chan]
	}));
	render.renderChannel(data.chan);

	// Queries do not automatically focus, unless the user did a whois
	if (data.chan.type === "query" && !data.shouldOpen) {
		return;
	}

	sidebar.find(".chan").sort(function (a, b) {
		return $(a).data("id") - $(b).data("id");
	}).last().click();
});

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(1);
var socket = __webpack_require__(4);
var render = __webpack_require__(15);
var chat = $("#chat");
var templates = __webpack_require__(10);

socket.on("more", function (data) {
	var documentFragment = render.buildChannelMessages(data.chan, data.messages);
	var chan = chat.find("#chan-" + data.chan).find(".messages");

	// get the scrollable wrapper around messages
	var scrollable = chan.closest(".chat");
	var heightOld = chan.height();

	// Remove the date-change marker we put at the top, because it may
	// not actually be a date change now
	var children = $(chan).children();
	if (children.eq(0).hasClass("date-marker-container")) {
		// Check top most child
		children.eq(0).remove();
	} else if (children.eq(1).hasClass("date-marker-container")) {
		// The unread-marker could be at index 0, which will cause the date-marker to become "stuck"
		children.eq(1).remove();
	}

	// Add the older messages
	chan.prepend(documentFragment).end();

	// restore scroll position
	var position = chan.height() - heightOld;
	scrollable.scrollTop(position);

	if (data.messages.length !== 100) {
		scrollable.find(".show-more").removeClass("show");
	}

	// Date change detect
	// Have to use data instaid of the documentFragment because it's being weird
	var lastDate = void 0;
	$(data.messages).each(function () {
		var msgData = this;
		var msgDate = new Date(msgData.time);
		var msg = $(chat.find("#chan-" + data.chan + " .messages #msg-" + msgData.id));

		// Top-most message in a channel
		if (!lastDate) {
			lastDate = msgDate;
			msg.before(templates.date_marker({ msgDate: msgDate }));
		}

		if (lastDate.toDateString() !== msgDate.toDateString()) {
			msg.before(templates.date_marker({ msgDate: msgDate }));
		}

		lastDate = msgDate;
	});

	scrollable.find(".show-more-button").prop("disabled", false);
});

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(1);
var socket = __webpack_require__(4);
var render = __webpack_require__(15);
var chat = $("#chat");
var templates = __webpack_require__(10);

socket.on("msg", function (data) {
	var msg = render.buildChatMessage(data);
	var target = "#chan-" + data.chan;
	var container = chat.find(target + " .messages");

	if (data.msg.type === "channel_list" || data.msg.type === "ban_list") {
		$(container).empty();
	}

	// Check if date changed
	var prevMsg = $(container.find(".msg")).last();
	var prevMsgTime = new Date(prevMsg.attr("data-time"));
	var msgTime = new Date(msg.attr("data-time"));

	// It's the first message in a channel/query
	if (prevMsg.length === 0) {
		container.append(templates.date_marker({ msgDate: msgTime }));
	}

	if (prevMsgTime.toDateString() !== msgTime.toDateString()) {
		prevMsg.after(templates.date_marker({ msgDate: msgTime }));
	}

	// Add message to the container
	container.append(msg).trigger("msg", [target, data]).trigger("keepToBottom");

	var lastVisible = container.find("div:visible").last();
	if (data.msg.self || lastVisible.hasClass("unread-marker") || lastVisible.hasClass("date-marker") && lastVisible.prev().hasClass("unread-marker")) {
		container.find(".unread-marker").appendTo(container);
	}
});

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(1);
var renderPreview = __webpack_require__(167);
var socket = __webpack_require__(4);

socket.on("msg:preview", function (data) {
	var msg = $("#msg-" + data.id);

	renderPreview(data.preview, msg);
});

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var socket = __webpack_require__(4);
var render = __webpack_require__(15);

socket.on("names", render.renderChannelUsers);

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(1);
var socket = __webpack_require__(4);
var render = __webpack_require__(15);
var sidebar = $("#sidebar");

socket.on("network", function (data) {
	render.renderNetworks(data);

	sidebar.find(".chan").last().trigger("click");

	$("#connect").find(".btn").prop("disabled", false).end();
});

socket.on("network_changed", function (data) {
	sidebar.find("#network-" + data.network).data("options", data.serverOptions);
});

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(1);
var socket = __webpack_require__(4);
var utils = __webpack_require__(28);
var sidebar = $("#sidebar");

socket.on("nick", function (data) {
	var id = data.network;
	var nick = data.nick;
	var network = sidebar.find("#network-" + id).data("nick", nick);
	if (network.find(".active").length) {
		utils.setNick(nick);
	}
});

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(1);
var socket = __webpack_require__(4);

socket.on("open", function (id) {
	// Another client opened the channel, clear the unread counter
	$("#sidebar").find(".chan[data-id='" + id + "'] .badge").removeClass("highlight").empty();
});

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(1);
var socket = __webpack_require__(4);
var sidebar = $("#sidebar");

socket.on("part", function (data) {
	var chanMenuItem = sidebar.find(".chan[data-id='" + data.chan + "']");

	// When parting from the active channel/query, jump to the network's lobby
	if (chanMenuItem.hasClass("active")) {
		chanMenuItem.parent(".network").find(".lobby").click();
	}

	chanMenuItem.remove();
	$("#chan-" + data.chan).remove();
});

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(1);
var socket = __webpack_require__(4);
var sidebar = $("#sidebar");

socket.on("quit", function (data) {
	var id = data.network;
	sidebar.find("#network-" + id).remove().end();
	var chan = sidebar.find(".chan").eq(0).trigger("click");
	if (chan.length === 0) {
		sidebar.find(".empty").show();
	}
});

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(1);
var socket = __webpack_require__(4);
var options = __webpack_require__(13);

socket.on("sync_sort", function (data) {
	// Syncs the order of channels or networks when they are reordered
	if (options.ignoreSortSync) {
		options.ignoreSortSync = false;
		return; // Ignore syncing because we 'caused' it
	}

	var type = data.type;
	var order = data.order;

	if (type === "networks") {
		var container = $(".networks");

		$.each(order, function (index, value) {
			var position = $(container.children()[index]);

			if (position.data("id") === value) {
				// Network in correct place
				return true; // No point in continuing
			}

			var network = container.find("#network-" + value);

			$(network).insertBefore(position);
		});
	} else if (type === "channels") {
		var network = $("#network-" + data.target);

		$.each(order, function (index, value) {
			if (index === 0) {
				// Shouldn't attempt to move lobby
				return true; // same as `continue` -> skip to next item
			}

			var position = $(network.children()[index]); // Target channel at position

			if (position.data("id") === value) {
				// Channel in correct place
				return true; // No point in continuing
			}

			var channel = network.find(".chan[data-id=" + value + "]"); // Channel at position

			$(channel).insertBefore(position);
		});
	}
});

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(1);
var socket = __webpack_require__(4);
var helpers_parse = __webpack_require__(6);

socket.on("topic", function (data) {
	var topic = $("#chan-" + data.chan).find(".header .topic");
	topic.html(helpers_parse(data.topic));
	// .attr() is safe escape-wise but consider the capabilities of the attribute
	topic.attr("title", data.topic);
});

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(1);
var socket = __webpack_require__(4);
var chat = $("#chat");

socket.on("users", function (data) {
	var chan = chat.find("#chan-" + data.chan);

	if (chan.hasClass("active")) {
		socket.emit("names", {
			target: data.chan
		});
	} else {
		chan.data("needsNamesRefresh", true);
	}
});

/***/ })
],[168]);


// WEBPACK FOOTER //
// js/bundle.js